webpackJsonp([18],{

/***/ 1041:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenizationLinkModal_vue__ = __webpack_require__(788);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60612a13_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenizationLinkModal_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60612a13"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenizationLinkModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60612a13_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenizationLinkModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1042:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1043);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("1de9936b", content, true, {});

/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".modal-body.tokenization-link-modal[data-v-60612a13]{padding:15px 20px}.copy-toast[data-v-60612a13]{position:fixed;top:35px;left:50%;-webkit-transform:translateX(-50%) translateY(-20px);transform:translateX(-50%) translateY(-20px);background:transparent;color:#4fb848;padding:12px 18px;border-radius:10px;font-size:14px;font-weight:500;opacity:0;visibility:hidden;-webkit-transition:all .25s ease;transition:all .25s ease;z-index:9999}.copy-toast.show[data-v-60612a13]{opacity:1;visibility:visible;-webkit-transform:translateX(-50%) translateY(0);transform:translateX(-50%) translateY(0)}.link-box[data-v-60612a13]{width:90%;padding:10px;background:rgba(79,184,72,.2);border-radius:4px}.link-box a.link-text[data-v-60612a13]{width:100%;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#4fb848}.btn.btn-copy[data-v-60612a13]{background:transparent;border:1px solid #4fb848;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.btn.btn-copy svg[data-v-60612a13]{color:#4fb848}.icon[data-v-60612a13]{width:20px;height:20px}.icon-fade-enter-active[data-v-60612a13],.icon-fade-leave-active[data-v-60612a13]{-webkit-transition:all .2s ease;transition:all .2s ease}.icon-fade-enter-from[data-v-60612a13]{opacity:0;-webkit-transform:scale(.6) rotate(-90deg);transform:scale(.6) rotate(-90deg)}.icon-fade-leave-to[data-v-60612a13]{opacity:0;-webkit-transform:scale(.6) rotate(90deg);transform:scale(.6) rotate(90deg)}", "", {"version":3,"sources":["/app/src/components/shared/TokenizationLinkModal.vue"],"names":[],"mappings":"AACA,qDACE,iBAAmB,CACpB,AACD,6BACE,eAAgB,AAChB,SAAU,AACV,SAAU,AACV,qDAAsD,AAC9C,6CAA8C,AACtD,uBAAwB,AACxB,cAAe,AACf,kBAAmB,AACnB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,UAAW,AACX,kBAAmB,AACnB,iCAAmC,AACnC,yBAA2B,AAC3B,YAAc,CACf,AACD,kCACE,UAAW,AACX,mBAAoB,AACpB,iDAAkD,AAC1C,wCAA0C,CACnD,AACD,2BACE,UAAW,AACX,aAAc,AAEd,8BAAmC,AACnC,iBAAmB,CACpB,AACD,uCACE,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,gBAAiB,AACjB,uBAAwB,AAExB,aAAe,CAChB,AACD,+BACE,uBAAwB,AACxB,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,mCACE,aAAe,CAChB,AACD,uBACE,WAAY,AACZ,WAAa,CACd,AAGD,kFAEE,gCAAkC,AAClC,uBAA0B,CAC3B,AAGD,uCACE,UAAW,AACX,2CAA6C,AACrC,kCAAqC,CAC9C,AAGD,qCACE,UAAW,AACX,0CAA4C,AACpC,iCAAoC,CAC7C","file":"TokenizationLinkModal.vue","sourcesContent":["\n.modal-body.tokenization-link-modal[data-v-60612a13] {\n  padding: 15px 20px;\n}\n.copy-toast[data-v-60612a13] {\n  position: fixed;\n  top: 35px;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-20px);\n          transform: translateX(-50%) translateY(-20px);\n  background: transparent;\n  color: #4fb848;\n  padding: 12px 18px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0;\n  visibility: hidden;\n  -webkit-transition: all 0.25s ease;\n  transition: all 0.25s ease;\n  z-index: 9999;\n}\n.copy-toast.show[data-v-60612a13] {\n  opacity: 1;\n  visibility: visible;\n  -webkit-transform: translateX(-50%) translateY(0);\n          transform: translateX(-50%) translateY(0);\n}\n.link-box[data-v-60612a13] {\n  width: 90%;\n  padding: 10px;\n  /* border: 1px solid #363636; */\n  background: rgba(79, 184, 72, 0.2);\n  border-radius: 4px;\n}\n.link-box a.link-text[data-v-60612a13] {\n  width: 100%;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* color: #363636; */\n  color: #4fb848;\n}\n.btn.btn-copy[data-v-60612a13] {\n  background: transparent;\n  border: 1px solid #4fb848;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.btn.btn-copy svg[data-v-60612a13] {\n  color: #4fb848;\n}\n.icon[data-v-60612a13] {\n  width: 20px;\n  height: 20px;\n}\n\n/* ENTER */\n.icon-fade-enter-active[data-v-60612a13],\n.icon-fade-leave-active[data-v-60612a13] {\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n\n/* MASUK */\n.icon-fade-enter-from[data-v-60612a13] {\n  opacity: 0;\n  -webkit-transform: scale(0.6) rotate(-90deg);\n          transform: scale(0.6) rotate(-90deg);\n}\n\n/* KELUAR */\n.icon-fade-leave-to[data-v-60612a13] {\n  opacity: 0;\n  -webkit-transform: scale(0.6) rotate(90deg);\n          transform: scale(0.6) rotate(90deg);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',[_c('div',{ref:"TokenizationLinkModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body tokenization-link-modal"},[_c('div',{staticClass:"copy-toast",class:{ show: _vm.isCopy }},[_vm._v("\n            Link copied to clipboard\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"d-flex justify-between items-center"},[_c('h4',{staticStyle:{"font-weight":"800"}},[_vm._v("Tokenization Link")]),_vm._v(" "),_c('button',{staticClass:"close btn-close-modal",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}},[_c('i',{staticClass:"ic-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mt-20 mb-20"},[_c('div',{staticClass:"d-flex justify-between"},[_c('div',{staticClass:"link-box"},[_c('a',{staticClass:"link-text",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.link))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-copy",attrs:{"type":"button","title":"Click to copy"},on:{"click":_vm.handleCopy}},[_c('transition',{attrs:{"name":"icon-fade","mode":"out-in"}},[(!_vm.isCopy)?_c('svg',{key:"copy",staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z","fill":"currentColor"}})]):_c('svg',{key:"check",staticClass:"icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M5 12l5 5L20 7","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])])],1)])])])])])])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1045:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section-header-info"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"content-header-info"},[_c('div',{staticClass:"col-sm-12"},[(_vm.isAllowToCreate)?_c('button',{staticClass:"btn btn-primary pull-left",on:{"click":function($event){return _vm.createItem()}}},[_c('span',[_vm._v("+")]),_vm._v(" Create New\n              ")]):_vm._e(),_vm._v(" "),_vm._m(1)])])])])])]),_vm._v(" "),_c('section',{staticClass:"middle-content"},[_c('div',{staticClass:"container big-container"},[_c('div',{staticClass:"row mb-20"},[_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":""}},[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Company","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},on:{"input":function($event){return _vm.getAll()}},model:{value:(_vm.table.companyIds),callback:function ($$v) {_vm.$set(_vm.table, "companyIds", $$v)},expression:"table.companyIds"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",attrs:{"placeholder":"Type","label":"text","options":_vm.typeOptions,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.value; }},on:{"input":function($event){return _vm.getAll()}},model:{value:(_vm.table.type),callback:function ($$v) {_vm.$set(_vm.table, "type", $$v)},expression:"table.type"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',{attrs:{"for":"search"}},[_vm._v("Search")]),_vm._v(" "),_c('div',{staticClass:"dataTables_filter",attrs:{"id":"filter-search"}},[_c('i',{staticClass:"ic-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.keyword),expression:"table.keyword"}],staticClass:"form-control",attrs:{"id":"search","type":"search","placeholder":"Search"},domProps:{"value":(_vm.table.keyword)},on:{"keyup":function($event){return _vm.onKeyupKeyword()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.table, "keyword", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"dataTables_length pull-right"},[_c('label',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.pageSize),expression:"table.pageSize"}],staticClass:"form-control v-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "pageSize", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.onChangePageSize()}]}},_vm._l((_vm.table.pageSizes),function(item){return _c('option',{key:item,domProps:{"value":item}},[_vm._v("\n                  "+_vm._s(item)+"\n                ")])}),0),_vm._v("\n              Entries")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-p15"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                  Company\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('company_name')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("\n                  Customer\n                  "),_c('span',{staticClass:"button-sort",on:{"click":function($event){return _vm.onClickSort('customer_name')}}},[_c('i',{staticClass:"ic-Switch-Vertical"})])]),_vm._v(" "),_c('th',[_vm._v("Phone")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.id,staticClass:"detail-row"},[_c('td',[_vm._v(_vm._s(item.companyName))]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(item.title ? ((item.title) + ".") : "")+"\n                  "+_vm._s(item.fullName)+"\n                ")]),_vm._v(" "),_c('td',[_c('span',{class:{ 'sts-danger': item.phones.length === 0 }},[_vm._v(_vm._s(_vm.printPhone(item.phones)))])]),_vm._v(" "),_c('td',[_c('span',{class:{ 'sts-danger': item.emails.length === 0 }},[_vm._v(_vm._s(_vm.printEmail(item.emails)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v("\n                  Corp. "+_vm._s(item.isAdmin ? "Admin" : "Booker")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('label',{staticClass:"cursor-pointer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.isActive),expression:"item.isActive"}],staticClass:"control-checkbox",attrs:{"type":"checkbox","disabled":!_vm.isAllowToUpdate},domProps:{"checked":Array.isArray(item.isActive)?_vm._i(item.isActive,null)>-1:(item.isActive)},on:{"change":[function($event){var $$a=item.isActive,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "isActive", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "isActive", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "isActive", $$c)}},function($event){return _vm.changeStatus(item)}]}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                      "+_vm._s(item.isActive ? "Active" : "Inactive")+"\n                    ")])])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('div',{staticClass:"dropdown"},[_vm._m(2,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-invoice-options",attrs:{"aria-labelledby":"dropdownMenu1"}},[(_vm.isAllowToUpdate)?_c('li',[_c('a',{on:{"click":function($event){return _vm.updateItem(item)}}},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(!item.isSync && _vm.isAllowToSync)?_c('li',[_c('a',{on:{"click":function($event){return _vm.openAuthModal(item)}}},[_vm._v("Sync")])]):_vm._e(),_vm._v(" "),(_vm.isAllowToDelete)?_c('li',[_c('a',{on:{"click":function($event){return _vm.confirmDelete(item)}}},[_vm._v("Delete")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openCardModal(item)}}},[_vm._v("Cards")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.openTokenizationLinkModal(item.id)}}},[_vm._v("Tokenization Link")])])])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"dataTables_info --blue25"},[_c('strong',[_vm._v(_vm._s(_vm.recordInfo))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('nav',{attrs:{"aria-label":"..."}},[_c('paginate',{attrs:{"page-count":_vm.table.totalPages,"click-handler":_vm.onNavigateCallback,"prev-text":'Previous',"next-text":'Next',"container-class":'pagination pull-right'},model:{value:(_vm.table.pageNumber),callback:function ($$v) {_vm.$set(_vm.table, "pageNumber", $$v)},expression:"table.pageNumber"}})],1)])])])]),_vm._v(" "),_c('div',{ref:"customermodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n                Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n              ")]):_vm._e()]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper modal-detail"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body mt-5"},[_c('ul',{staticClass:"nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"},[_c('li',{class:[_vm.activeTab === 'general' ? 'active' : '']},[_c('a',{attrs:{"href":"#customer-general","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'general'}}},[_c('span',{staticClass:"required"},[_vm._v("General")])])]),_vm._v(" "),_c('li',{class:[_vm.activeTab === 'contact' ? 'active' : '']},[_c('a',{attrs:{"href":"#customer-contact","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 'contact'}}},[_c('span',{staticClass:"required"},[_vm._v("Contact")])])])]),_vm._v(" "),(_vm.$v.model.$error)?_c('div',{staticClass:"summary-error"},[_vm._v("\n                  This form has errors\n                ")]):_vm._e(),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'general' ? 'in active' : ''],attrs:{"id":"customer-general"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Company")]),_vm._v(" "),_c('v-select',{staticClass:"v-search-select",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.companyId.$error,
                          },attrs:{"placeholder":"","label":"name","options":_vm.companies,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.id; }},model:{value:(_vm.model.companyId),callback:function ($$v) {_vm.$set(_vm.model, "companyId", $$v)},expression:"model.companyId"}}),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.companyId.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Company is required")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Select Title")]),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle",attrs:{"data-toggle":"buttons"}},_vm._l((_vm.titles),function(item,index){return _c('label',{key:index,staticClass:"btn",class:{
                              active: _vm.model.title === item.value,
                              'field-error':
                                _vm.isSubmitted && _vm.$v.model.title.$error,
                            },on:{"click":function($event){_vm.model.title = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.title),expression:"model.title"}],attrs:{"type":"radio","name":"title","autocomplete":"off"},domProps:{"value":item.value,"checked":_vm.model.title === item.value,"checked":_vm._q(_vm.model.title,item.value)},on:{"change":function($event){return _vm.$set(_vm.model, "title", item.value)}}}),_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])}),0),_vm._v(" "),(_vm.isSubmitted && !_vm.$v.model.title.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Title is required")]):_vm._e()]),_vm._v(" "),(_vm.model.title === 'Other')?_c('div',{staticClass:"form-group"},[_c('label',{},[_vm._v("Title")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.otherTitle),expression:"model.otherTitle"}],staticClass:"form-control alphabets-only",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.model.otherTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "otherTitle", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Full Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.fullName),expression:"model.fullName"}],staticClass:"form-control alphabets-only",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.fullName.$error,
                          },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.model.fullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "fullName", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.fullName.$error)?_c('div',[(!_vm.$v.model.fullName.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.fullName.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Full Name must be less than\n                            "+_vm._s(_vm.$v.model.fullName.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.isUpdate)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.password),expression:"model.password"}],staticClass:"form-control",class:{
                            'field-error':
                              _vm.isSubmitted && _vm.$v.model.password.$error,
                          },attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.model.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.model.password.$error)?_c('div',[(!_vm.$v.model.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                            "+_vm._s(_vm.$v.model.password.$params.maxLength.max)+"\n                            characters")]):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Is Admin?")]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isAdmin),expression:"model.isAdmin"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isAdminFlagNo","value":"false"},domProps:{"checked":_vm.model.isAdmin == false,"checked":_vm._q(_vm.model.isAdmin,"false")},on:{"change":function($event){return _vm.$set(_vm.model, "isAdmin", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("No")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isAdmin),expression:"model.isAdmin"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isAdminFlagYes","value":"true"},domProps:{"checked":_vm.model.isAdmin == true,"checked":_vm._q(_vm.model.isAdmin,"true")},on:{"change":function($event){return _vm.$set(_vm.model, "isAdmin", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Yes")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Is Person In Charge?")]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isPersonInCharge),expression:"model.isPersonInCharge"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isPersonInChargeNo","value":"false"},domProps:{"checked":_vm.model.isPersonInCharge == false,"checked":_vm._q(_vm.model.isPersonInCharge,"false")},on:{"change":function($event){return _vm.$set(_vm.model, "isPersonInCharge", "false")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("No")])]),_vm._v(" "),_c('label',{staticClass:"cursor-pointer w-max-content"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.isPersonInCharge),expression:"model.isPersonInCharge"}],staticClass:"control-radio",attrs:{"type":"radio","name":"isPersonInChargeYes","value":"true"},domProps:{"checked":_vm.model.isPersonInCharge == true,"checked":_vm._q(_vm.model.isPersonInCharge,"true")},on:{"change":function($event){return _vm.$set(_vm.model, "isPersonInCharge", "true")}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("Yes")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Preferred Location")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.name),expression:"location.name"}],staticClass:"form-control",attrs:{"type":"text","name":"location_name","autocomplete":"off"},domProps:{"value":(_vm.location.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":""}},[_vm._v("Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.location.address),expression:"location.address"}],staticClass:"form-control",attrs:{"rows":"4","name":"location_address","autocomplete":"off"},domProps:{"value":(_vm.location.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.location, "address", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","id":"btn-map"},on:{"click":function($event){$event.preventDefault();return _vm.openMapModal()}}},[_c('i',{staticClass:"ic-map"}),_vm._v("\n                        Select Location by Map\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",class:[_vm.activeTab === 'contact' ? 'in active' : ''],attrs:{"id":"customer-contact"}},[_c('div',[_c('h4',[_vm._v("Phone")]),_vm._v(" "),_vm._l((_vm.model.modifiedPhones),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Phone")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"form-group"},[_c('v-select',{staticClass:"v-search-select",class:{
                                        'field-error':
                                          _vm.isSubmitted &&
                                          _vm.$v.model.modifiedPhones.$each[index]
                                            .code.$error,
                                      },attrs:{"placeholder":"","label":"label","options":_vm.phoneCodes,"filter":_vm.searchPhoneCode,"clearable":true,"searchable":true,"filterable":true,"reduce":function (option) { return option.dial; }},on:{"input":function($event){return _vm.onChangeCustomerItem(item)}},scopedSlots:_vm._u([{key:"option",fn:function(option){return [_c('div',{staticClass:"phone-wrapper"},[_c('div',{staticClass:"phone-icon",class:option.icon}),_vm._v(" "),_c('div',{staticClass:"phone-text"},[_vm._v("\n                                            "+_vm._s(option.country)+"\n                                          ")])])]}}],null,true),model:{value:(item.code),callback:function ($$v) {_vm.$set(item, "code", $$v)},expression:"item.code"}}),_vm._v(" "),(
                                        _vm.isSubmitted &&
                                        !_vm.$v.model.modifiedPhones.$each[index]
                                          .code.required
                                      )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Code is required")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.number),expression:"item.number"}],staticClass:"form-control numbers-only",class:{
                                        'field-error':
                                          _vm.isSubmitted &&
                                          _vm.$v.model.modifiedPhones.$each[index]
                                            .number.$error,
                                      },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(item.number)},on:{"keyup":function($event){return _vm.onChangeCustomerItem(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "number", $event.target.value)}}}),_vm._v(" "),(
                                        _vm.isSubmitted &&
                                        _vm.$v.model.modifiedPhones.$each[index]
                                          .number.$error
                                      )?_c('div',[(
                                          !_vm.$v.model.modifiedPhones.$each[
                                            index
                                          ].number.required
                                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number is required")]):_vm._e(),_vm._v(" "),(
                                          !_vm.$v.model.modifiedPhones.$each[
                                            index
                                          ].number.maxLength
                                        )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Phone Number must be less than\n                                        "+_vm._s(_vm.$v.model.modifiedPhones.$each[index]
                                            .number.$params.maxLength.max)+"\n                                        characters")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                        _vm.model.modifiedPhones &&
                                        _vm.model.modifiedPhones.length > 0
                                      )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removePhone(index)}}},[_vm._v("\n                                      Remove\n                                    ")]):_vm._e()])])])])]):_vm._e()])}),_vm._v(" "),(_vm.phoneCodes && _vm.model.modifiedPhones)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[(_vm.model.modifiedPhones)?_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addPhone()}}},[_vm._v("\n                              Add\n                            ")]):_vm._e()])]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"20px"}},[_c('h4',[_vm._v("Email")]),_vm._v(" "),_vm._l((_vm.model.modifiedEmails),function(item,index){return _c('div',{key:index,staticClass:"row"},[(item.state !== 'Deleted')?_c('div',[_c('div',{staticClass:"col-sm-12"},[_c('label',{staticClass:"required"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.email),expression:"item.email"}],staticClass:"form-control",class:{
                                    'field-error':
                                      _vm.isSubmitted &&
                                      _vm.$v.model.modifiedEmails.$each[index]
                                        .email.$error,
                                  },attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(item.email)},on:{"keyup":function($event){return _vm.onChangeCustomerItem(item)},"input":function($event){if($event.target.composing){ return; }_vm.$set(item, "email", $event.target.value)}}}),_vm._v(" "),(
                                    _vm.isSubmitted &&
                                    _vm.$v.model.modifiedEmails.$each[index].email
                                      .$error
                                  )?_c('div',[(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.required
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is required")]):_vm._e(),_vm._v(" "),(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.email
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email is invalid")]):_vm._e(),_vm._v(" "),(
                                      !_vm.$v.model.modifiedEmails.$each[index]
                                        .email.maxLength
                                    )?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Email must be less than\n                                    "+_vm._s(_vm.$v.model.modifiedEmails.$each[index]
                                        .email.$params.maxLength.max)+"\n                                    characters")]):_vm._e()]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[(
                                    _vm.model.modifiedEmails &&
                                    _vm.model.modifiedEmails.length > 0
                                  )?_c('button',{staticClass:"btn btn-default sts-danger",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.removeEmail(index)}}},[_vm._v("\n                                  Remove\n                                ")]):_vm._e()])])]):_vm._e()])}),_vm._v(" "),(_vm.model.modifiedEmails)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.addEmail()}}},[_vm._v("\n                              Add\n                            ")])])]):_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      "+_vm._s(_vm.isUpdate ? "Save Changes" : "Save")+"\n                    ")])])])])])])])])])]),_vm._v(" "),_c('div',{ref:"customerpasswordmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitAuth()}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"required"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.auth.password),expression:"auth.password"}],staticClass:"form-control",class:{
                        'field-error': _vm.isSubmitted && _vm.$v.auth.password.$error,
                      },attrs:{"type":"password","autocomplete":"off"},domProps:{"value":(_vm.auth.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.auth, "password", $event.target.value)}}}),_vm._v(" "),(_vm.isSubmitted && _vm.$v.auth.password.$error)?_c('div',[(!_vm.$v.auth.password.required)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password is required")]):_vm._e(),_vm._v(" "),(!_vm.$v.auth.password.maxLength)?_c('small',{staticClass:"form-text sts-danger"},[_vm._v("Password must be less than\n                        "+_vm._s(_vm.$v.auth.password.$params.maxLength.max)+"\n                        characters")]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(5)])])])])])])])]),_vm._v(" "),_c('div',{ref:"mapmodal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-header modal-new",class:{ update: _vm.isUpdate }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer Location")]),_vm._v(" "),(_vm.model.modifiedDate)?_c('h6',[_vm._v("\n              Last Updated: "+_vm._s(_vm.model.modifiedDate.stringFullDate)+"\n            ")]):_vm._e()]),_vm._v(" "),_vm._m(6)])]),_vm._v(" "),_vm._m(7)])]),_vm._v(" "),_c('div',{ref:"cardListModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-base"},[_c('div',{staticClass:"modal-content"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('div',{staticClass:"flex-column gap-20 mb-60"},[_vm._l((_vm.paymentList),function(item,index){return _c('div',{key:index,staticClass:"d-flex justify-between card-list-wrapper",class:{
                      'bg-gray-ddd': _vm.isExpired(
                        item.expiryMonth,
                        item.expiryYear
                      ),
                    }},[_c('div',{staticClass:"d-flex",staticStyle:{"gap":"20px"}},[_c('div',{staticClass:"img-card-logo"},[_c('img',{attrs:{"src":item.brand === 'VISA'
                              ? '/static/assets/images/credit-card-logo/visa-logo.svg'
                              : item.brand === 'JCB'
                              ? '/static/assets/images/credit-card-logo/jcb-logo.svg'
                              : item.brand === 'AMEX'
                              ? '/static/assets/images/credit-card-logo/amex-logo.svg'
                              : item.brand === 'Mastercard'
                              ? '/static/assets/images/credit-card-logo/mastercard-logo.svg'
                              : item.brand === 'Diners Club International'
                              ? '/static/assets/images/credit-card-logo/diners-logo.svg'
                              : item.brand === 'Discover'
                              ? '/static/assets/images/credit-card-logo/discover-logo.svg'
                              : '/static/assets/images/credit-card-logo/unionpay-logo.svg',"alt":"card-logo"}})]),_vm._v(" "),_c('div',{staticClass:"detail-card-logo flex-column"},[_c('div',{staticClass:"credit-card-name"},[_vm._v("\n                          "+_vm._s(item.cardHolderName ? item.cardHolderName : "N/A")+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"credit-card-number"},[_vm._v("\n                          **** **** **** "+_vm._s(item.last4)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"credit-card-exp"},[_vm._v("\n                          expires on "+_vm._s(item.expiryMonth)+"/"+_vm._s(item.expiryYear)+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('div',{staticClass:"d-flex justify-end gap-5"},[(item.type)?_c('div',{class:item.type === 'Business'
                              ? 'badge-business'
                              : 'badge-personal'},[_vm._v("\n                          "+_vm._s(item.type)+"\n                        ")]):_vm._e(),_vm._v(" "),(item.isDefault)?_c('div',{staticClass:"badge-default"},[_vm._v("\n                          Default\n                        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown"},[_vm._m(9,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-credit-card-list-options",attrs:{"aria-labelledby":"dropdownMenu1"}},[(
                                !item.isDefault &&
                                !_vm.isExpired(item.expiryMonth, item.expiryYear)
                              )?_c('li',[_c('a',{attrs:{"type":"button"},on:{"click":function($event){return _vm.setDefaultCard(item)}}},[_vm._v("Set Default")])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"type":"button"},on:{"click":function($event){return _vm.editCard(item)}}},[_vm._v("Edit")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"type":"button"},on:{"click":function($event){return _vm.openDeleteCardModal(item.id)}}},[_vm._v("Delete")])])])])])])])}),_vm._v(" "),(_vm.paymentList.length === 0)?_c('div',[_c('div',{staticClass:"credit-card-svg"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21.9 21.9L2.1 2.1L.69 3.51l1.55 1.55c-.15.28-.23.6-.23.94L2 18c0 1.11.89 2 2 2h13.17l3.31 3.31l1.42-1.41zM4 12V8h1.17l4 4H4zm2.83-8H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L14.83 12H20V8h-9.17l-4-4z","fill":"currentColor"}})])]),_vm._v(" "),_c('p',{staticClass:"credit-card-offline-text"},[_vm._v("\n                      No credit card saved\n                    ")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"d-flex justify-end gap-20"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n                    Cancel\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.openPaymentModal()}}},[_vm._v("\n                    Add New Card\n                  ")])])])])])])])])]),_vm._v(" "),_c('div',{ref:"paymentModal",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('FormCard',{ref:"formCard",attrs:{"width":"100%","nameBtn":"Save Card","customerId":_vm.selectedCustomerId,"showTitle":false,"awClientSecret":_vm.awClientSecret},on:{"submit":function($event){return _vm.submitCardDetail()}}})],1)])])])])])]),_vm._v(" "),_c('div',{ref:"editCard",staticClass:"modal fade",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-content-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submitEditCard()}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 mb-20"},[_c('label',{},[_vm._v("Card Holder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCard.cardHolderName),expression:"selectedCard.cardHolderName"}],staticClass:"form-control alphabets-only",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedCard.cardHolderName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedCard, "cardHolderName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-20"},[_c('label',{staticClass:"required"},[_vm._v("Card Type")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.cardType),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{ 'pl-20': index > 0 },on:{"click":function($event){_vm.selectedCard.type = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCard.type),expression:"selectedCard.type"}],staticClass:"control-radio",attrs:{"type":"radio"},domProps:{"value":item.value,"checked":_vm.selectedCard.type === item.value,"checked":_vm._q(_vm.selectedCard.type,item.value)},on:{"change":function($event){return _vm.$set(_vm.selectedCard, "type", item.value)}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n                            "+_vm._s(item.text)+"\n                          ")])])}),0)]),_vm._v(" "),_vm._m(12)])])])])])])])])]),_vm._v(" "),_c('tokenization-link-modal'),_vm._v(" "),_c('deleteModal',{on:{"submit":_vm.submitDelete}}),_vm._v(" "),_c('deleteModal',{attrs:{"idModal":"deleteCardModal","subContent":"Deleting a card is a non-reversible action."},on:{"submit":_vm.deleteCard}}),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"aria-label":"breadcrumb"}},[_c('ol',{staticClass:"breadcrumb"},[_c('li',{staticClass:"breadcrumb-item"},[_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("Corporate")])]),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item active",attrs:{"aria-current":"page"}},[_vm._v("\n                Customer\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl-30 pull-left"},[_c('h2',[_vm._v("\n                  Customer "),_c('span',[_c('i',{staticClass:"ic-office"})])]),_vm._v(" "),_c('p',[_vm._v("Manage your customers and booker details.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{attrs:{"src":"/static/assets/images/three-dots.svg","alt":"three-dots-options","width":"15"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Customer Authentication")]),_vm._v(" "),_c('h6',[_vm._v("Please fill all information below.")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("\n                      Save Password\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"gmap-wrapper"},[_c('div',{staticClass:"pac-card",attrs:{"id":"pac-card"}},[_c('div',{attrs:{"id":"pac-container"}},[_c('input',{attrs:{"id":"pac-input","type":"text","placeholder":"Enter a location"}})])]),_vm._v(" "),_c('div',{attrs:{"id":"map"}}),_vm._v(" "),_c('div',{staticClass:"modal-footer text-center"},[_c('div',{attrs:{"id":"gmap-custom-control"}},[_c('button',{staticClass:"btn btn-default remove-location",attrs:{"type":"button"}},[_vm._v("\n                  Reset\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary save-location",attrs:{"type":"button"}},[_vm._v("\n                  Apply\n                ")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Cards")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn dropdown-toggle",attrs:{"type":"button","id":"dropdownMenuButton","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{attrs:{"src":"/static/assets/images/three-dots.svg","alt":"three-dots-options","width":"15"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Add New Card")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v("Edit Card")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('i',{staticClass:"ic-close"})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 mb-20"},[_c('div',{staticClass:"d-flex w-full gap-5"},[_c('button',{staticClass:"btn btn-default",staticStyle:{"width":"50%"},attrs:{"type":"button"}},[_vm._v("\n                          Cancel\n                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"50%"},attrs:{"type":"submit"}},[_vm._v("\n                          Submit\n                        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__(787);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a890af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__(1045);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67a890af_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(469));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(468));

var _alphaNum = _interopRequireDefault(__webpack_require__(471));

var _numeric = _interopRequireDefault(__webpack_require__(472));

var _between = _interopRequireDefault(__webpack_require__(473));

var _email = _interopRequireDefault(__webpack_require__(474));

var _ipAddress = _interopRequireDefault(__webpack_require__(475));

var _macAddress = _interopRequireDefault(__webpack_require__(476));

var _maxLength = _interopRequireDefault(__webpack_require__(477));

var _minLength = _interopRequireDefault(__webpack_require__(478));

var _required = _interopRequireDefault(__webpack_require__(479));

var _requiredIf = _interopRequireDefault(__webpack_require__(480));

var _requiredUnless = _interopRequireDefault(__webpack_require__(481));

var _sameAs = _interopRequireDefault(__webpack_require__(482));

var _url = _interopRequireDefault(__webpack_require__(483));

var _or = _interopRequireDefault(__webpack_require__(484));

var _and = _interopRequireDefault(__webpack_require__(485));

var _not = _interopRequireDefault(__webpack_require__(486));

var _minValue = _interopRequireDefault(__webpack_require__(487));

var _maxValue = _interopRequireDefault(__webpack_require__(488));

var _integer = _interopRequireDefault(__webpack_require__(489));

var _decimal = _interopRequireDefault(__webpack_require__(490));

var helpers = _interopRequireWildcard(__webpack_require__(465));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    idModal: {
      type: String,
      default: "deletemodal"
    },
    subContent: {
      type: String,
      default: "Do you want to delete this record? This process cannot be undone."
    }
  },
  methods: {
    cancel: function cancel() {
      $("#" + this.idModal).modal("hide");
      this.$emit("cancel");
    },
    submit: function submit() {
      $("#" + this.idModal).modal("hide");
      this.$emit("submit");
    }
  }
});

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","BRAND_NAME":"Trransfer","VUE_APP_GOOGLE_MAPS_KEY":"AIzaSyDwoOCBqFXIhPMWg922paZIpeVZkudwH6I","VUE_APP_BASE_API":"https://prod-gateway-opsicar.idteknologia.net","VUE_APP_AUTH_HOST":"https://authservice.trransfer.com","VUE_APP_CDN":"https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com","VUE_APP_GOOGLE_TAG_ID":"UA-171512499-1","VUE_APP_SUPPORT_WIDGET_ID":"51000003059","VUE_APP_SUPPORT_WIDGET_SOURCE":"https://aus-widget.freshworks.com/widgets/51000003059.js"}).BUILD === 'web' ? __webpack_require__(470).withParams : __webpack_require__(235).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__ = __webpack_require__(492);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6d05f94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"role":"dialog","id":_vm.idModal}},[_c('div',{staticClass:"modal-dialog modal-xs"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body modal-confirmation"},[_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"modal-wrapper"},[_vm._m(0),_vm._v(" "),_c('header',[_vm._v("Are you sure?")]),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.subContent)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v("\n                  Cancel\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("\n                  Yes, delete\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delete-icon"},[_c('i',{staticClass:"ic-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(498), __esModule: true };

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(57);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(36);
__webpack_require__(25);
module.exports = __webpack_require__(499);


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var get = __webpack_require__(58);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/companies';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list' + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getAllActive: function getAllActive() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list/active').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt('return', _context2.sent);

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  create: function create(request) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt('return', _context3.sent);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  update: function update(request) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt('return', _context4.sent);

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + '/status', request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt('return', _context5.sent);

            case 3:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  delete: function _delete(id) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + '/' + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt('return', _context6.sent);

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + '/api/master/countryPhones';

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + '/list').then(function (response) {
                return response.data.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _canvas = void 0;
var _marker = void 0;
var _markers = [];
var _circle = void 0;
var _infoWindow = void 0;
var _hasAutocomplete = false;
var _hasMarker = false;
var _hasInfoWindow = false;
var _hasConfirmLocationCallback = false;
var _hasRemoveLocationCallback = false;
var _hasDrawGeometryCallback = false;
var _hasAutoCompleteGetPlaceCallback = false;
var _hasMarkerChangeCallback = false;
var _confirmLocationClassName = "save-location";
var _removeLocationClassName = "remove-location";
var _drawGeometryLocationClassName = "draw-geometry";

function _isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onClickCanvas(latLng) {
  _marker.setPosition(latLng);
  _marker.setVisible(true);
}

function _onPlaceChangedAutoComplete(autocomplete) {
  // hide marker
  if (_hasMarker) {
    _marker.setVisible(false);
  }

  var place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);

  // display marker
  if (_hasMarker) {
    _marker.setPosition(place.geometry.location);
    _marker.setVisible(true);
  }

  return place;
}

function _removeCircle() {
  if (_circle !== undefined) {
    _circle.setMap(null);
  }
}

function _removeInfoWindow() {
  if (_infoWindow !== undefined) {
    _infoWindow.close();
  }
}

function _initializeCircle(coordinate, visibleCircle) {
  // remove existing objects
  _removeCircle();
  _removeInfoWindow();

  // draw circle
  _circle = new google.maps.Circle({
    center: {
      lat: coordinate.lat,
      lng: coordinate.lng
    },
    radius: coordinate.rad,
    editable: true,
    draggable: true
  });

  // fill on canvas
  if (visibleCircle) {
    var showInfoWindow = function showInfoWindow() {
      var content = "Latitude: " + _circle.getCenter().lat() + "<br>" + "Longitude: " + _circle.getCenter().lng() + "<br>" + "Radius: " + _circle.getRadius().toString();

      // Set the info window's content and position.
      _infoWindow.setContent(content);
      _infoWindow.setPosition(_circle.getBounds().getNorthEast());
      _infoWindow.open(_canvas);
    };

    // attach listener


    _circle.setMap(_canvas);

    // create window
    _infoWindow = new google.maps.InfoWindow();

    _circle.addListener("radius_changed", showInfoWindow);
    _circle.addListener("center_changed", showInfoWindow);
  }
}

var MaverickMap = function () {
  function MaverickMap(config) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickMap);

    // mapId: string
    // lat: double
    // lng: double
    // autocomplete: bool
    // marker: bool
    // infoWindow: bool
    // confirmLocationCallback: callback
    // removeLocationCallback: callback
    // drawGeometryCallback: callback
    // autoCompleteGetPlaceCallback: callback
    // markerChangeCallback: callback
    // confirmLocationClassName: string
    // removeLocationClassName: string
    // drawGeometryLocationClassName: string
    this.config = config;
    this.enableMarkerClick = config.enableMarkerClick !== false;

    _hasAutocomplete = config.autocomplete !== undefined && config.autocomplete === true;
    _hasMarker = config.marker !== undefined && config.marker === true;
    _hasInfoWindow = config.infoWindow !== undefined && config.infoWindow === true;
    _hasConfirmLocationCallback = config.confirmLocationCallback !== undefined;
    _hasRemoveLocationCallback = config.removeLocationCallback !== undefined;
    _hasDrawGeometryCallback = config.drawGeometryCallback !== undefined;
    _hasAutoCompleteGetPlaceCallback = config.autoCompleteGetPlaceCallback !== undefined;
    _hasMarkerChangeCallback = config.markerChangeCallback !== undefined;
    _confirmLocationClassName = config.confirmLocationClassName !== config.confirmLocationClassName ? config.confirmLocationClassName : _confirmLocationClassName;
    _removeLocationClassName = config.removeLocationClassName !== config.removeLocationClassName ? config.removeLocationClassName : _removeLocationClassName;
    _drawGeometryLocationClassName = config.drawGeometryLocationClassName !== config.drawGeometryLocationClassName ? config.drawGeometryLocationClassName : _drawGeometryLocationClassName;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickMap, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;

      // reset
      _canvas = undefined;
      _marker = undefined;
      _circle = undefined;
      _infoWindow = undefined;

      if (_isEmpty(this.config)) {
        return;
      }

      _canvas = new google.maps.Map(document.getElementById(this.config.mapId), {
        center: {
          lat: this.config.lat,
          lng: this.config.lng
        },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      _canvas.addListener("bounds_changed", function () {
        var container = document.getElementsByClassName("pac-container")[0];
        if (container !== undefined && container !== null) {
          container.setAttribute("style", "z-index: 2000;");
        }
      });

      // Marker
      if (_hasMarker) {
        _marker = new google.maps.Marker({
          map: _canvas,
          anchorPoint: new google.maps.Point(0, -29)
        });

        // attach event listener
        if (this.enableMarkerClick) {
          _canvas.addListener("click", function (e) {
            var latLng = e.latLng;
            _onClickCanvas(latLng);
            if (_hasMarkerChangeCallback) {
              _this.config.markerChangeCallback({
                lat: latLng.lat(),
                lng: latLng.lng()
              });
            }
          });
        }
      }

      // Autocomplete
      if (_hasAutocomplete) {
        _canvas.controls[google.maps.ControlPosition.TOP_LEFT].push(document.getElementById("pac-card"));

        var autocomplete = new google.maps.places.Autocomplete(document.getElementById("pac-input"));

        // Bind the map's bounds (viewport) property to the autocomplete object,
        // so that the autocomplete requests use the current map bounds for the
        // bounds option in the request.
        autocomplete.bindTo("bounds", _canvas);

        // Set the data fields to return when the user selects a place.
        autocomplete.setFields(["address_components", "formatted_address", "geometry", "name", "place_id"]);

        // attach event listener
        autocomplete.addListener("place_changed", function (_) {
          var place = _onPlaceChangedAutoComplete(autocomplete);
          if (_hasAutoCompleteGetPlaceCallback) {
            _this.config.autoCompleteGetPlaceCallback(place);
          }
        });
      }

      var customControl = document.getElementById("gmap-custom-control");
      if (customControl) {
        // EventHandler: Save Location
        var saveLocationControl = customControl.getElementsByClassName(_confirmLocationClassName);
        if (_hasConfirmLocationCallback && saveLocationControl.length > 0) {
          saveLocationControl[0].addEventListener("click", function () {
            var coordinate = {};
            if (_marker !== undefined) {
              coordinate.lat = _marker.getPosition().lat();
              coordinate.lng = _marker.getPosition().lng();
            } else if (_circle !== undefined) {
              coordinate.lat = _circle.getCenter().lat();
              coordinate.lng = _circle.getCenter().lng();
              coordinate.rad = _circle.getRadius();
            }

            // callback
            _this.config.confirmLocationCallback(coordinate);
          });
        }

        // EventHandler: Remove Location
        var removeLocationControl = customControl.getElementsByClassName(_removeLocationClassName);
        if (_hasRemoveLocationCallback && removeLocationControl.length > 0) {
          removeLocationControl[0].addEventListener("click", function () {
            // remove objects
            _this.hideMarker();
            _removeCircle();
            _removeInfoWindow();

            // callback
            _this.config.removeLocationCallback();
          });
        }

        // EventHandler: Draw Geometry
        var drawGeometryControl = customControl.getElementsByClassName(_drawGeometryLocationClassName);
        if (_hasDrawGeometryCallback && drawGeometryControl.length > 0) {
          drawGeometryControl[0].addEventListener("click", function () {
            _initializeCircle({
              lat: _canvas.getCenter().lat(),
              lng: _canvas.getCenter().lng(),
              rad: 700
            }, true);
          });
        }
      }
    }
  }, {
    key: "showInfoWindow",
    value: function showInfoWindow(position, content) {
      if (_hasInfoWindow) {
        // initialize if empty
        if (_infoWindow === undefined) {
          _infoWindow = new google.maps.InfoWindow();
        }

        var latLng = new google.maps.LatLng(position.latitude, position.longitude);

        // Set the info window's content and position.
        _infoWindow.setContent(content);
        _infoWindow.setPosition(latLng);
        _infoWindow.open(_canvas);

        _canvas.setCenter(latLng);
        _canvas.setZoom(20);
      }
    }
  }, {
    key: "showMarker",
    value: function showMarker(center) {
      var iconUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // if (_hasMarker) {
      //   _marker.setPosition(center);
      //   _marker.setVisible(true);
      // }

      if (_hasMarker) {
        // Hapus marker lama jika ada
        if (_marker) {
          _marker.setMap(null);
        }

        // Buat marker baru
        var markerOptions = {
          position: center,
          map: _canvas
        };

        if (iconUrl) {
          markerOptions.icon = {
            url: iconUrl
          };
        }

        _marker = new google.maps.Marker(markerOptions);
        _marker.setVisible(true);
      }
      _canvas.setCenter(center);
      _canvas.setZoom(15);
    }
  }, {
    key: "hideMarker",
    value: function hideMarker() {
      if (_hasMarker) {
        _marker.setVisible(false);
      }
      _canvas.setZoom(15);
    }
  }, {
    key: "setCircleCenter",
    value: function setCircleCenter(center, radius, visibleCircle) {
      if (_circle === undefined) {
        _initializeCircle({
          lat: center.lat(),
          lng: center.lng(),
          rad: radius
        }, visibleCircle);
      } else {
        _circle.setCenter(center);
        _circle.setRadius(radius);
      }
      _canvas.fitBounds(_circle.getBounds());
      _canvas.setZoom(12);
    }
  }, {
    key: "addMarker",
    value: function addMarker(_ref) {
      var lat = _ref.lat,
          lng = _ref.lng,
          icon = _ref.icon;
      var infoContent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: _canvas,
        anchorPoint: new google.maps.Point(0, -29),
        icon: {
          url: icon ? icon : "/static/assets/images/dot-marker.svg",
          scaledSize: new google.maps.Size(35, 35)
        }
      });
      _markers.push(marker);

      if (infoContent) {
        var infoWindow = new google.maps.InfoWindow({
          content: infoContent
        });

        var isOpen = true;

        infoWindow.open(_canvas, marker);

        marker.addListener("click", function () {
          if (isOpen) {
            infoWindow.close();
          } else {
            infoWindow.open(_canvas, marker);
          }
          isOpen = !isOpen;
        });
      }
    }
  }, {
    key: "clearMarkers",
    value: function clearMarkers() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_markers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var m = _step.value;

          m.setMap(null);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      _markers = [];
    }
  }, {
    key: "fitToMarkers",
    value: function fitToMarkers() {
      if (_markers.length === 0) return;
      var bounds = new google.maps.LatLngBounds();
      _markers.forEach(function (marker) {
        return bounds.extend(marker.getPosition());
      });
      _canvas.fitBounds(bounds);
    }
  }, {
    key: "setCenter",
    value: function setCenter(_ref2) {
      var lat = _ref2.lat,
          lng = _ref2.lng;
      var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (_canvas) {
        var centerLatLng = new google.maps.LatLng(lat, lng);
        _canvas.setCenter(centerLatLng);

        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "setZoom",
    value: function setZoom() {
      var zoom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (_canvas) {
        if (zoom !== null) {
          _canvas.setZoom(zoom);
        }
      }
    }
  }, {
    key: "isInRadius",
    get: function get() {
      var result = false;
      if (_circle !== undefined) {
        result = google.maps.geometry.spherical.computeDistanceBetween(_marker.getPosition(), _circle.getCenter()) <= _circle.getRadius();
        if (!result) {
          _marker.setVisible(false);
        }
      }
      return result;
    }
  }]);

  return MaverickMap;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickMap);

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_master_customer_customerService_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__airwallex_components_sdk__ = __webpack_require__(637);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    width: {
      type: String,
      default: "40%"
    },
    nameBtn: {
      type: String,
      default: "Save Card"
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    awClientSecret: {
      type: Object,
      default: {}
    },
    urlSearchParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    customerId: {
      type: String,
      default: ""
    },
    paymentPage: {
      type: Boolean,
      default: false
    },
    invoiceNumber: {
      type: String,
      default: ""
    },
    invoiceType: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      selectedCardType: "Business",
      cardHolderName: "",
      cardType: [{ value: "Business", text: "Business" }, { value: "Personal", text: "Personal" }],
      cardNumber: null,
      expirationDate: null,
      cvc: null,
      cardNumberMsg: null,
      expirationDateMsg: null,
      cvcMsg: null,
      statusConfirmation: false,
      isLoading: false,
      msg: "Please wait"
    };
  },

  methods: {
    resetAirwallex: function resetAirwallex() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.cardNumber) _this.cardNumber.unmount();
                if (_this.expirationDate) _this.expirationDate.unmount();
                if (_this.cvc) _this.cvc.unmount();
                _this.cardHolderName = "";
                _this.cardNumberMsg = null;
                _this.expirationDateMsg = null;
                _this.cvcMsg = null;
                _context.next = 9;
                return _this.initAirwallex();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    initAirwallex: function initAirwallex() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var hostname;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hostname = window.location.hostname;
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_3__airwallex_components_sdk__["b" /* init */])({
                  env: hostname === "app.trransfer.com" ? "prod" : "demo",
                  enabledElements: ["payments"]
                });

              case 3:
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_3__airwallex_components_sdk__["a" /* createElement */])("cardNumber");

              case 5:
                _this2.cardNumber = _context2.sent;
                _context2.next = 8;
                return Object(__WEBPACK_IMPORTED_MODULE_3__airwallex_components_sdk__["a" /* createElement */])("expiry");

              case 8:
                _this2.expirationDate = _context2.sent;
                _context2.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_3__airwallex_components_sdk__["a" /* createElement */])("cvc");

              case 11:
                _this2.cvc = _context2.sent;


                _this2.cardNumber.mount("card_number");
                _this2.expirationDate.mount("expiration_date");
                _this2.cvc.mount("security_code");

                _this2.cardNumber.on("change", function (event) {
                  if (event.detail && event.detail.error) {
                    _this2.cardNumberMsg = event.detail.error.message;
                  } else {
                    _this2.cardNumberMsg = null;
                  }
                });

                _this2.expirationDate.on("change", function (event) {
                  if (event.detail && event.detail.error) {
                    _this2.expirationDateMsg = event.detail.error.message;
                  } else {
                    _this2.expirationDateMsg = null;
                  }
                });

                _this2.cvc.on("change", function (event) {
                  if (event.detail && event.detail.error) {
                    _this2.cvcMsg = event.detail.error.message;
                  } else {
                    _this2.cvcMsg = null;
                  }
                });

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this3.cardNumberMsg) {
                  _context3.next = 3;
                  break;
                }

                _this3.$notification.error("" + _this3.cardNumberMsg, {
                  title: "Error"
                });

                return _context3.abrupt("return");

              case 3:
                if (!_this3.expirationDateMsg) {
                  _context3.next = 6;
                  break;
                }

                _this3.$notification.error("" + _this3.expirationDateMsg, {
                  title: "Error"
                });

                return _context3.abrupt("return");

              case 6:
                if (!_this3.cvcMsg) {
                  _context3.next = 9;
                  break;
                }

                _this3.$notification.error("" + _this3.cvcMsg, {
                  title: "Error"
                });

                return _context3.abrupt("return");

              case 9:

                if (_this3.invoiceNumber && _this3.invoiceType === "Monthly") {
                  _this3.$emit("confirmation");
                } else {
                  _this3.processingPayment();
                }

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    processingPayment: function processingPayment() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response, payload, verifyPaymentMethod, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.paymentPage) {
                  _context4.next = 8;
                  break;
                }

                if (_this4.statusConfirmation) {
                  _context4.next = 5;
                  break;
                }

                _this4.$emit("confirmationSubmit");
                _this4.statusConfirmation = true;
                return _context4.abrupt("return");

              case 5:
                _this4.$eventBus.$emit("loading", {
                  msg: "Payment in progress, please do not refresh or close this browser.",
                  isLoading: true
                });
                _context4.next = 9;
                break;

              case 8:
                _this4.isLoading = true;

              case 9:
                _context4.prev = 9;
                _context4.next = 12;
                return _this4.cardNumber.createPaymentConsent({
                  customer_id: _this4.awClientSecret.airwallexCustomerId,
                  client_secret: _this4.awClientSecret.clientSecret,
                  currency: "SGD",
                  next_triggered_by: "merchant"
                });

              case 12:
                response = _context4.sent;

                if (!response) {
                  _context4.next = 21;
                  break;
                }

                payload = {
                  customerId: _this4.customerId,
                  last4: response.payment_method.last4
                };
                _context4.next = 17;
                return __WEBPACK_IMPORTED_MODULE_2__services_master_customer_customerService_js__["a" /* default */].verifyPaymentMethod(payload);

              case 17:
                verifyPaymentMethod = _context4.sent;

                if (!verifyPaymentMethod.isSuccess) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 21;
                return _this4.attachPaymentMethod(response);

              case 21:
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4["catch"](9);

                if (_this4.paymentPage) {
                  _this4.$eventBus.$emit("loading", {
                    msg: "Please wait",
                    isLoading: false
                  });
                }
                if (_context4.t0 && _context4.t0.errors) {
                  for (index = 0; index < _context4.t0.errors.length; index++) {
                    _this4.$notification.error(_context4.t0.errors[index], { title: "Error" });
                  }
                } else {
                  _this4.$notification.error(_context4.t0.message, { title: "Error" });
                }

              case 27:
                _context4.prev = 27;

                _this4.isLoading = false;
                return _context4.finish(27);

              case 30:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[9, 23, 27, 30]]);
      }))();
    },
    attachPaymentMethod: function attachPaymentMethod(paymentConsentResponse) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var payload, response, paymentMethodId, index;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                payload = {
                  refCustomerId: paymentConsentResponse.customer_id,
                  refPaymentConsentId: paymentConsentResponse.payment_consent_id,
                  refPaymentMethodId: paymentConsentResponse.payment_method.id,
                  paymentCardType: _this5.selectedCardType,
                  cardHolderName: _this5.cardHolderName
                };
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__services_master_customer_customerService_js__["a" /* default */].attachPaymentMethod(payload);

              case 4:
                response = _context5.sent;

                if (response.isSuccess) {
                  _this5.$notification.success("Card successfully saved.", {
                    title: "Success"
                  });
                  paymentMethodId = response.data.id;

                  _this5.$emit("submit", paymentMethodId);
                }
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                if (_this5.paymentPage) {
                  _this5.$eventBus.$emit("loading", {
                    msg: "Please wait",
                    isLoading: false
                  });
                }
                if (_context5.t0.errors) {
                  for (index = 0; index < _context5.t0.errors.length; index++) {
                    _this5.$notification.error(_context5.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 8]]);
      }))();
    }
  }
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);



var endpoint = "https://prod-gateway-opsicar.idteknologia.net" + "/api/master/customers";
var config = {
  headers: { _pub: "true" }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filter) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/search" + filter).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getListOfPaymentMethods: function getListOfPaymentMethods(customerId) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + customerId + "/payment-methods").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context2.abrupt("return", _context2.sent);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getTokenizationLink: function getTokenizationLink(customerId) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + customerId + "/tokenization-link").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getPaymentMethodById: function getPaymentMethodById(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/payment-methods/" + id).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getAirwallexClientSecret: function getAirwallexClientSecret(customerId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/" + customerId + "/airwallex-client-secret").then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getPublicAirwallexClientSecret: function getPublicAirwallexClientSecret(request) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(endpoint + "/airwallex-client-secret?" + request, config).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  create: function create(request) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context7.abrupt("return", _context7.sent);

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  verifyPaymentMethod: function verifyPaymentMethod(request) {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(endpoint + "/payment-methods/verify", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context8.abrupt("return", _context8.sent);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  update: function update(request) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint, request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context9.abrupt("return", _context9.sent);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  changeCardType: function changeCardType(request) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/payment-methods/card-type", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context10.abrupt("return", _context10.sent);

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  syncAuth: function syncAuth(request) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/sync", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context11.abrupt("return", _context11.sent);

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  changeStatus: function changeStatus(request) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/status", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context12.abrupt("return", _context12.sent);

            case 3:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  attachPaymentMethod: function attachPaymentMethod(request) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/payment-methods", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context13.abrupt("return", _context13.sent);

            case 3:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  publicAttachPaymentMethod: function publicAttachPaymentMethod(request) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/payment-methods/public-attach", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context14.abrupt("return", _context14.sent);

            case 3:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  setDefaultPaymentMethod: function setDefaultPaymentMethod(request) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + "/default-payment-methods", request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context15.abrupt("return", _context15.sent);

            case 3:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },
  updatePaymentMethod: function updatePaymentMethod(id, request) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(endpoint + ("/payment-methods/" + id), request).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context16.abrupt("return", _context16.sent);

            case 3:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  },
  delete: function _delete(id) {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context17.abrupt("return", _context17.sent);

            case 3:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, _this17);
    }))();
  },
  deletePaymentMethod: function deletePaymentMethod(id) {
    var _this18 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(endpoint + ("/payment-methods/" + id)).then(function (response) {
                return response.data;
              }).catch(function (error) {
                throw error.response.data;
              });

            case 2:
              return _context18.abrupt("return", _context18.sent);

            case 3:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, _this18);
    }))();
  }
});

/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



var _geocoder = void 0;

var MaverickGeocoding = function () {
  function MaverickGeocoding() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MaverickGeocoding);

    _geocoder = new google.maps.Geocoder();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MaverickGeocoding, [{
    key: 'geocode',
    value: function geocode(latLng) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _geocoder.geocode({
          location: latLng
        }, function (results, status) {
          if (status === "OK") {
            var result = results[0];
            var address = result.formatted_address;
            var name = '';
            if (result.address_components !== undefined && result.address_components !== null && result.address_components.length > 0) {
              var administrative_area_level_4 = '';
              var administrative_area_level_3 = '';
              var administrative_area_level_2 = '';
              var administrative_area_level_1 = '';
              var country = '';
              for (var index = 0; index < result.address_components.length; index++) {
                var addressComponent = result.address_components[index];
                if (addressComponent.types.includes('administrative_area_level_4')) {
                  administrative_area_level_4 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_3')) {
                  administrative_area_level_3 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_2')) {
                  administrative_area_level_2 = addressComponent.long_name;
                } else if (addressComponent.types.includes('administrative_area_level_1')) {
                  administrative_area_level_1 = addressComponent.long_name;
                } else if (addressComponent.types.includes('country')) {
                  country = addressComponent.long_name;
                }
              }
              if (administrative_area_level_4 !== '') {
                name = administrative_area_level_4;
              } else if (administrative_area_level_3 !== '') {
                name = administrative_area_level_3;
              } else if (administrative_area_level_2 !== '') {
                name = administrative_area_level_2;
              } else {
                name = address.split(',')[0];
              }

              // append city and country
              if (administrative_area_level_1 !== '' && country !== '') {
                name += ', ' + administrative_area_level_1 + ', ' + country;
              }
            }
            resolve({
              address: address,
              name: name,
              latitude: latLng.lat,
              longitude: latLng.lng
            });
          } else {
            reject();
          }
        });
      });
    }
  }]);

  return MaverickGeocoding;
}();

/* harmony default export */ __webpack_exports__["a"] = (MaverickGeocoding);

/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCard_vue__ = __webpack_require__(610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114cc4d3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCard_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(635)
}
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-114cc4d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_114cc4d3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(384)("77565470", content, true, {});

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(383)(true);
// imports


// module
exports.push([module.i, ".form-payment-information[data-v-114cc4d3]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.form-payment-information h2[data-v-114cc4d3]{font-weight:700}#btn-payment-information.btn-primary[data-v-114cc4d3]{width:100%!important;padding:10px}label[data-v-114cc4d3]{color:#777!important;display:block!important;font-size:.8667rem!important}.instructional-text-wrapper #title[data-v-114cc4d3]{font-size:16px;font-weight:700}.instructional-text-wrapper p[data-v-114cc4d3]{font-size:.8667rem;text-align:justify}", "", {"version":3,"sources":["/app/src/components/shared/FormCard.vue"],"names":[],"mappings":"AACA,2CACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,8CACE,eAAiB,CAClB,AACD,sDACE,qBAAuB,AACvB,YAAc,CACf,AACD,uBACE,qBAAuB,AACvB,wBAA0B,AAC1B,4BAAgC,CACjC,AACD,oDACE,eAAgB,AAChB,eAAiB,CAClB,AACD,+CACE,mBAAqB,AACrB,kBAAoB,CACrB","file":"FormCard.vue","sourcesContent":["\n.form-payment-information[data-v-114cc4d3] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.form-payment-information h2[data-v-114cc4d3] {\n  font-weight: 700;\n}\n#btn-payment-information.btn-primary[data-v-114cc4d3] {\n  width: 100% !important;\n  padding: 10px;\n}\nlabel[data-v-114cc4d3] {\n  color: #777 !important;\n  display: block !important;\n  font-size: 0.8667rem !important;\n}\n.instructional-text-wrapper #title[data-v-114cc4d3] {\n  font-size: 16px;\n  font-weight: 700;\n}\n.instructional-text-wrapper p[data-v-114cc4d3] {\n  font-size: 0.8667rem;\n  text-align: justify;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__ = __webpack_require__(638);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var name = "@airwallex/components-sdk";
var version = "1.35.1";
var main = "./lib/index.js";
var module = "./lib/index.mjs";
var types = "./lib/index.d.ts";
var files = [
	"lib/**"
];
var license = "MIT";
var scripts = {
	"load-types": "node ./load-types.js && yarn prettier -w src/types/*d.ts",
	prebuild: "yarn clean",
	build: "yarn rollup --config",
	postbuild: "yarn bundle-types",
	"bundle-types": "dts-bundle-generator -o ./lib/index.d.ts ./src/index.ts",
	clean: "rm -rf dist lib",
	lint: "eslint \"src/**/*.ts*\"",
	test: "jest",
	sonar: "sonar-scanner",
	release: "semantic-release",
	"lint-stage": "lint-staged",
	prepare: "husky"
};
var prettier = {
	semi: true,
	singleQuote: true,
	printWidth: 80,
	trailingComma: "all"
};
var publishConfig = {
	access: "public"
};
var devDependencies = {
	"@babel/preset-typescript": "^7.18.6",
	"@rollup/plugin-commonjs": "^25.0.7",
	"@rollup/plugin-json": "^6.1.0",
	"@rollup/plugin-node-resolve": "^15.2.3",
	"@rollup/plugin-terser": "^0.4.4",
	"@rollup/plugin-typescript": "^11.1.6",
	"@semantic-release/changelog": "^5.0.1",
	"@semantic-release/commit-analyzer": "^8.0.1",
	"@semantic-release/git": "^9.0.0",
	"@semantic-release/gitlab": "^6.1.0",
	"@semantic-release/release-notes-generator": "^9.0.0",
	"@swc/core": "^1.3.46",
	"@types/jest": "^29.5.0",
	"@typescript-eslint/eslint-plugin": "^5.57.0",
	"@typescript-eslint/parser": "^5.57.0",
	"dts-bundle-generator": "^9.0.0",
	eslint: "^7.23.0",
	"eslint-config-prettier": "^8.3.0",
	"eslint-plugin-prettier": "^5.1.3",
	husky: "^9.0.11",
	jest: "^29.5.0",
	"jest-environment-jsdom": "^29.5.0",
	"lint-staged": "^15.2.7",
	prettier: "^3.3.2",
	rollup: "^4.9.6",
	"semantic-release": "^17.3.8",
	"sonarqube-scanner": "^3.0.1",
	"ts-jest": "^29.0.5",
	"ts-loader": "^9.5.1",
	tslib: "^2.6.2",
	typescript: "^4.5.2"
};
var dependencies = {
	"@airwallex/airtracker": "^3.0.0"
};
var packageJson = {
	name: name,
	version: version,
	main: main,
	module: module,
	types: types,
	files: files,
	license: license,
	scripts: scripts,
	prettier: prettier,
	"lint-staged": {
	"src/**/*.{ts,tsx}": [
		"yarn lint"
	],
	"src/**/*.{js,jsx,ts,tsx,json,css,scss,md}": "prettier --write"
},
	publishConfig: publishConfig,
	devDependencies: devDependencies,
	dependencies: dependencies
};

var airTrackerENV = {
    dev: __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].staging,
    staging: __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].staging,
    demo: __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].demo,
    prod: __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].production
};
var initializeAirTracker = function (env, clientId) {
    if (env === void 0) { env = __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].production; }
    if (!window._AirwallexSDKs.airTracker) {
        window._AirwallexSDKs.airTracker = new __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["b" /* default */]({
            config: {
                appName: 'components-sdk',
                appVersion: packageJson.version,
                env: airTrackerENV[env] || __WEBPACK_IMPORTED_MODULE_0__airwallex_airtracker__["a" /* Environment */].production
            }
        });
        window._AirwallexSDKs.airTracker.updateCommonData({ clientId: clientId });
    }
    return window._AirwallexSDKs.airTracker;
};
var maskPII = function (data) {
    if (typeof data !== 'object') {
        return data;
    }
    try {
        var result_1 = JSON.parse(JSON.stringify(data));
        Object.keys(result_1).forEach(function (key) {
            if (typeof key === 'string' &&
                ['auth', 'code'].some(function (sens) { return key.includes(sens); })) {
                result_1[key] = '***';
            }
        });
        return result_1;
    }
    catch (_a) {
        return data;
    }
};
var logError = function (eventName, data) {
    var _a, _b;
    (_b = (_a = window._AirwallexSDKs) === null || _a === void 0 ? void 0 : _a.airTracker) === null || _b === void 0 ? void 0 : _b.error(eventName, __assign(__assign({}, data), { context: 'components-sdk' }));
};
var logWarning = function (eventName, data) {
    var _a;
    (_a = window._AirwallexSDKs.airTracker) === null || _a === void 0 ? void 0 : _a.warn(eventName, __assign(__assign({}, data), { context: 'components-sdk' }));
};
var logInfo = function (eventName, data) {
    var _a;
    (_a = window._AirwallexSDKs.airTracker) === null || _a === void 0 ? void 0 : _a.info(eventName, __assign(__assign({}, data), { context: 'components-sdk' }));
};

var LoadScriptError = /** @class */ (function (_super) {
    __extends(LoadScriptError, _super);
    function LoadScriptError(message) {
        var _this = _super.call(this, message) || this;
        _this.code = 'LOAD_SCRIPT_ERROR';
        return _this;
    }
    return LoadScriptError;
}(Error));

var _a, _b;
var ENV;
(function (ENV) {
    ENV["dev"] = "dev";
    ENV["staging"] = "staging";
    ENV["demo"] = "demo";
    ENV["prod"] = "prod";
    ENV["sandbox"] = "sandbox";
})(ENV || (ENV = {}));
var PA_STATIC_HOST = (_a = {},
    _a[ENV.dev] = 'https://checkout-staging.airwallex.com',
    _a[ENV.staging] = 'https://checkout-staging.airwallex.com',
    _a[ENV.demo] = 'https://checkout-demo.airwallex.com',
    _a[ENV.prod] = 'https://checkout.airwallex.com',
    _a[ENV.sandbox] = 'https://checkout.sandbox.airwallex.com',
    _a);
var STATIC_HOST = (_b = {},
    _b[ENV.dev] = 'https://static-staging.airwallex.com',
    _b[ENV.staging] = 'https://static-staging.airwallex.com',
    _b[ENV.demo] = 'https://static-demo.airwallex.com',
    _b[ENV.prod] = 'https://static.airwallex.com',
    _b[ENV.sandbox] = 'https://static.sandbox.airwallex.com',
    _b);
var SDK_CONTROLLER = 'sdkController';
var PAYMENTS = 'payments';
var SDK_URL_MAPPING = {
    kyc: '/widgets/kyc/sdk/v1/index.js',
    rfi: '/widgets/kycRfi/sdk/v1/index.js',
    paymentsKyb: '/widgets/paymentsKyb/sdk/v1/index.js',
    sdkController: '/widgets/sdk-controller/sdk/v1/index.js',
    payouts: '/widgets/payouts/sdk/v1/index.js',
    payments: '/assets/elements.bundle.min.js',
    sca: '/hosted-sca/sdk/v1/index.js',
    taxForm: '/widgets/taxForm/sdk/v1/index.js',
    billing: '/widgets/checkout/sdk/v1/index.js',
    balance: '/widgets/embedded-balance/sdk/v1/index.js'
};
var ELEMENT_TO_SDK = {
    // legacy
    kyc: 'kyc',
    paymentsKyb: 'paymentsKyb',
    // rfi elements
    kycRfi: 'rfi',
    transactionRfi: 'rfi',
    paymentEnablementRfi: 'rfi',
    lendingRfi: 'rfi',
    mrmRfi: 'rfi',
    // payouts elements
    payoutForm: 'payouts',
    beneficiaryForm: 'payouts',
    // payment elements
    hpp: 'payments',
    cvc: 'payments',
    card: 'payments',
    expiry: 'payments',
    dropIn: 'payments',
    cardNumber: 'payments',
    applePayButton: 'payments',
    googlePayButton: 'payments',
    krCardNumber: 'payments',
    krCardIdentifier: 'payments',
    krCardExpiry: 'payments',
    krCardPswFirstTwo: 'payments',
    // sca elements
    scaSetup: 'sca',
    scaVerify: 'sca',
    scaManagement: 'sca',
    taxForm: 'taxForm',
    // billing elements
    embeddedCheckout: 'billing',
    // balance elements
    balanceOverview: 'balance',
    balanceDetail: 'balance',
    balanceActivities: 'balance',
    balanceActivityDetails: 'balance',
    balanceHistoryChart: 'balance',
    balanceInfo: 'balance',
    balanceScheduledTransactions: 'balance',
    balanceList: 'balance'
};
var ELEMENT_GROUP_TO_ELEMENT = {
    payments: [
        'hpp',
        'cvc',
        'card',
        'expiry',
        'dropIn',
        'cardNumber',
        'applePayButton',
        'googlePayButton',
        'krCardNumber',
        'krCardIdentifier',
        'krCardExpiry',
        'krCardPswFirstTwo',
    ],
    payouts: ['payoutForm', 'beneficiaryForm'],
    onboarding: ['kyc', 'paymentsKyb'],
    risk: [
        'scaSetup',
        'scaVerify',
        'scaManagement',
        'transactionRfi',
        'kycRfi',
        'paymentEnablementRfi',
        'lendingRfi',
        'mrmRfi',
    ],
    billing: ['embeddedCheckout'],
    balance: [
        'balanceOverview',
        'balanceDetail',
        'balanceActivities',
        'balanceHistoryChart',
        'balanceInfo',
        'balanceScheduledTransactions',
        'balanceList',
        'balanceActivityDetails',
    ]
};
var SDK_DEPENDENCIES = {
    billing: ['payments']
};
var DOMAIN_FUNCTIONS_NAMESPACES = ['payments', 'sca', 'billing'];

var InvalidStaticResourceError = /** @class */ (function (_super) {
    __extends(InvalidStaticResourceError, _super);
    function InvalidStaticResourceError(message) {
        var _this = _super.call(this, message) || this;
        _this.code = 'INVALID_STATIC_RESOURCE_ERROR';
        return _this;
    }
    return InvalidStaticResourceError;
}(Error));

var timestamp = Date.now();
var isElementGroup = function (name) { return Object.keys(ELEMENT_GROUP_TO_ELEMENT).includes(name); };
var sleep = function (delay) {
    if (delay === void 0) { delay = 500; }
    return new Promise(function (resolve) { return window.setTimeout(resolve, delay); });
};
var getSDKByElementName = function (elementName) {
    return ELEMENT_TO_SDK[elementName];
};
var getHost = function (name, env) {
    var host = name === PAYMENTS ? PA_STATIC_HOST : STATIC_HOST;
    return host[env] || host.prod;
};
/**
 * get the elements and sdks that need registry by controller
 * @param enabledElements the enabledElements passed in init params
 * @returns array of deduplicated elementName pair with sdkName
 */
var getSDKsByEnabledElements = function (enabledElements) {
    // e.g., ['hpp', 'payoutForm', 'kyc', 'kyc']
    var usedElements = enabledElements.reduce(function (elementArr, enabledEle) {
        return elementArr.concat(isElementGroup(enabledEle)
            ? ELEMENT_GROUP_TO_ELEMENT[enabledEle]
            : enabledEle);
    }, []);
    return Array.from(new Set(usedElements)).map(function (elementName) { return ({
        elementName: elementName,
        sdkName: getSDKByElementName(elementName)
    }); });
};
var getFunctionsByEnabledElements = function (enabledElements) {
    return Array.from(new Set(getSDKsByEnabledElements(enabledElements)
        .map(function (_a) {
        var sdkName = _a.sdkName;
        return sdkName;
    })
        .filter(function (usedSdkName) {
        return DOMAIN_FUNCTIONS_NAMESPACES.includes(usedSdkName);
    })));
};
var getWindowSDKInstanceName = function (name) {
    return name === 'payments' ? 'payment' : name;
};
/**
 * get the CDN url of a specific package
 * @param name declare the element name
 * @param env the environment of package
 * @returns string the CDN url
 */
var getSDKUrl = function (_a) {
    var name = _a.name, _b = _a.env, env = _b === void 0 ? ENV.prod : _b;
    var staticHost = getHost(name, env);
    var elementUri = SDK_URL_MAPPING[name];
    if (!elementUri) {
        logError('[components-sdk] Element static resource not found', {
            sdkName: name
        });
        throw new InvalidStaticResourceError("Element ".concat(name, " static resource URL is invalid."));
    }
    return "".concat(staticHost).concat(elementUri, "?ts=").concat(timestamp);
};
var getFunctionsInstanceWithNamespace = function () {
    return DOMAIN_FUNCTIONS_NAMESPACES.reduce(function (result, namespace) {
        var _a;
        return (__assign(__assign({}, result), (_a = {}, _a[namespace] = window._AirwallexSDKs.__controller__.internalSDKs[namespace], _a)));
    }, {});
};
var getSDKDependencies = function (sdkName) {
    return SDK_DEPENDENCIES[sdkName] || [];
};
var now = function () { return Math.floor(performance.now()); };

var createScript = function (url) {
    var script = document.createElement('script');
    script.src = url;
    script.type = 'module';
    var parentDom = document.head || document.body;
    parentDom.appendChild(script);
    return script;
};
var MAX_RETRY_COUNT = 3;
var loadScript = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var retryCount, tryToResolve;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof window === 'undefined') {
                    throw new Error('Please load script in browser environment');
                }
                retryCount = 0;
                tryToResolve = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var start, urlObj, script;
                    return __generator(this, function (_a) {
                        start = now();
                        if (retryCount > 0 && url.includes('?ts=')) {
                            urlObj = new URL(url, window.location.href);
                            urlObj.searchParams.set('ts', "".concat(Date.now()));
                            url = urlObj.toString();
                        }
                        script = createScript(url);
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                script.addEventListener('load', function () {
                                    var end = now();
                                    logInfo('[components-sdk] SDK script loaded', {
                                        scriptUrl: url,
                                        start: start,
                                        latency: end - start,
                                        end: end,
                                        retryCount: retryCount
                                    });
                                    resolve(true);
                                });
                                script.addEventListener('error', function (err) {
                                    script.remove();
                                    console.error(err);
                                    var end = now();
                                    logError('[components-sdk] Failed to load script', {
                                        scriptUrl: url,
                                        error: err,
                                        start: start,
                                        latency: end - start,
                                        end: end,
                                        retryCount: retryCount
                                    });
                                    reject(new LoadScriptError("Failed to load Airwallex SDK scripts: ".concat(url)));
                                });
                            })];
                    });
                }); };
                _a.label = 1;
            case 1:
                if (!(retryCount < MAX_RETRY_COUNT)) return [3 /*break*/, 7];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 6]);
                return [4 /*yield*/, tryToResolve()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                _a.sent();
                retryCount++;
                return [4 /*yield*/, sleep()];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [3 /*break*/, 1];
            case 7:
                logError('[components-sdk] Failed to load script after retry', {
                    scriptUrl: url,
                    retryCount: retryCount
                });
                throw new LoadScriptError("Failed to load Airwallex SDK scripts: ".concat(url));
        }
    });
}); };

var InstanceNotFoundError = /** @class */ (function (_super) {
    __extends(InstanceNotFoundError, _super);
    function InstanceNotFoundError(message) {
        var _this = _super.call(this, message) || this;
        _this.code = 'INSTANCE_NOT_FOUND_ERROR';
        return _this;
    }
    return InstanceNotFoundError;
}(Error));

var initPromise;
/**
 * ensure one script one promise
 */
var promiseMap = new Map();
/**
 * get the Promise to load the element script
 * @param scriptName declare the SDK or Functions namespace
 * @param env the resource url
 * @returns Promise to load the script
 */
var getLoadScriptPromise = function (_a) {
    var env = _a.env, scriptName = _a.scriptName;
    var url = getSDKUrl({ name: scriptName, env: env });
    // if promise was made
    var sdkPromise = promiseMap.get(scriptName);
    if (sdkPromise) {
        return sdkPromise;
    }
    var loadScriptPromise = loadScript(url);
    promiseMap.set(scriptName, loadScriptPromise);
    return loadScriptPromise;
};
/**
 * Load an SDK script along with its dependencies
 * @param scriptName the SDK name to load
 * @param env the environment
 * @returns Promise that resolves when the SDK and all its dependencies are loaded
 */
var loadSDKWithDependencies = function (_a) {
    var env = _a.env, scriptName = _a.scriptName;
    return __awaiter(void 0, void 0, void 0, function () {
        var dependencies;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dependencies = getSDKDependencies(scriptName);
                    if (!(dependencies.length > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(dependencies.map(function (dep) { return getLoadScriptPromise({ env: env, scriptName: dep }); }))];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/, getLoadScriptPromise({ env: env, scriptName: scriptName })];
            }
        });
    });
};
/**
 * SDK init, load controller script
 * @param options SDK init options
 * @returns Promise to load the script
 */
var init = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (typeof window === 'undefined') {
            throw new Error('Please call the `init()` function in a browser environment.');
        }
        // initialize airTracker
        initializeAirTracker(options.env, options.clientId);
        logInfo('[components-sdk] SDK init start', {
            options: maskPII(options),
            start: now()
        });
        initPromise = new Promise(function (resolve, reject) {
            var _a;
            var initOptions = __assign(__assign({}, options), { env: options.env && ENV[options.env] ? options.env : ENV.prod });
            window.AirwallexComponentsSDK.__env__ = initOptions.env;
            // load SDK controller script
            var controllerPromise = getLoadScriptPromise({
                env: initOptions.env,
                scriptName: SDK_CONTROLLER
            }).then(function () { return window._AirwallexSDKs.__controller__.init(initOptions); });
            // For old version backward compatibility
            var enabledElements = (_a = options.enabledElements) !== null && _a !== void 0 ? _a : [];
            var functionsNamespaces = getFunctionsByEnabledElements(enabledElements);
            // load SDK functions scripts
            var functionsPromises = functionsNamespaces.map(function (functionsNamespace) {
                return loadSDKWithDependencies({
                    env: initOptions.env,
                    scriptName: functionsNamespace
                })
                    .then(function () { return controllerPromise; })
                    .then(function () {
                    var instance = window._AirwallexSDKs[getWindowSDKInstanceName(functionsNamespace)];
                    if (!instance) {
                        logError('[components-sdk] SDK instance not found', {
                            functionsNamespace: functionsNamespace,
                            windowSDKInstanceName: getWindowSDKInstanceName(functionsNamespace)
                        });
                        throw new InstanceNotFoundError("SDK instance not found");
                    }
                    return window._AirwallexSDKs.__controller__.registerFunctions({
                        functionsNamespace: functionsNamespace,
                        instance: instance
                    });
                });
            });
            // load SDK elements scripts
            var enabledSDKs = getSDKsByEnabledElements(enabledElements);
            var elementsPromises = enabledSDKs.map(function (_a) {
                var sdkNamespace = _a.sdkName, elementName = _a.elementName;
                return loadSDKWithDependencies({
                    scriptName: sdkNamespace,
                    env: initOptions.env
                })
                    .then(function () { return controllerPromise; })
                    .then(function () {
                    var instance = window._AirwallexSDKs[getWindowSDKInstanceName(sdkNamespace)];
                    if (!instance) {
                        logError('[components-sdk] SDK instance not found', {
                            sdkName: sdkNamespace,
                            windowSDKInstanceName: getWindowSDKInstanceName(sdkNamespace)
                        });
                        throw new InstanceNotFoundError("SDK instance not found");
                    }
                    return window._AirwallexSDKs.__controller__.registerElement({
                        sdkName: sdkNamespace,
                        elementName: elementName,
                        instance: instance
                    });
                });
            });
            Promise.all(__spreadArray(__spreadArray([controllerPromise], functionsPromises, true), elementsPromises, true))
                .then(function () {
                logInfo('[components-sdk] SDK initialized', {
                    options: maskPII(options),
                    start: now()
                });
                resolve(getFunctionsInstanceWithNamespace());
            })["catch"](function (error) {
                if (!error.code) {
                    logError('[components-sdk] Unexpected errors when init', { error: error });
                }
                reject(error);
            });
        });
        return [2 /*return*/, initPromise];
    });
}); };
/**
 * load SDK element script and call SDK instance.createElement.
 * @param elementName the element name to create
 * @param options createElement options
 * @returns return type of SDK instance.createElement
 */
var createElement = function (elementName, options) { return __awaiter(void 0, void 0, void 0, function () {
    var sdkName, start, elementInstance, end, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!elementName) {
                    throw new Error('Element type is missing. Please specify a valid element.');
                }
                logInfo('[components-sdk] SDK createElement start', {
                    elementName: elementName,
                    options: maskPII(options),
                    timestamp: now()
                });
                if (!initPromise) {
                    logWarning('[components-sdk] Did not call init before createElement');
                    throw new Error('Please initialize the Element before creating it.');
                }
                return [4 /*yield*/, initPromise];
            case 1:
                _a.sent();
                sdkName = getSDKByElementName(elementName);
                if (!sdkName) {
                    throw new Error("`createElement()` with type `".concat(elementName, "` is not supported. Please specify a valid Element type."));
                }
                start = now();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 7]);
                return [4 /*yield*/, loadSDKWithDependencies({
                        scriptName: sdkName,
                        env: window.AirwallexComponentsSDK.__env__ || ENV.prod
                    })];
            case 3:
                _a.sent();
                return [4 /*yield*/, window._AirwallexSDKs.__controller__.registerElement({
                        sdkName: sdkName,
                        elementName: elementName,
                        instance: window._AirwallexSDKs[getWindowSDKInstanceName(sdkName)]
                    })];
            case 4:
                _a.sent();
                return [4 /*yield*/, window._AirwallexSDKs.__controller__.createElement(elementName, options)];
            case 5:
                elementInstance = _a.sent();
                end = now();
                logInfo('[components-sdk] SDK createElement being called', {
                    elementName: elementName,
                    options: maskPII(options),
                    start: start,
                    latency: end - start,
                    end: end
                });
                return [3 /*break*/, 7];
            case 6:
                error_1 = _a.sent();
                if (!error_1.code) {
                    logError('[components-sdk] Unexpected errors when createElement', {
                        error: error_1
                    });
                }
                else {
                    throw error_1;
                }
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/, elementInstance];
        }
    });
}); };

/**
 * List of scripts to prefetch
 */
var PREFETCH_SCRIPT_LIST = [SDK_CONTROLLER, PAYMENTS];
/**
 * Prefetch scripts by preload link, only for production as there's no environment context before SDK init
 */
var prefetchScripts = function () {
    PREFETCH_SCRIPT_LIST.forEach(function (scriptName) {
        var url = getSDKUrl({ name: scriptName, env: ENV.prod });
        var preloadLink = document.createElement('link');
        preloadLink.href = url;
        preloadLink.rel = 'modulepreload';
        preloadLink.as = 'script';
        var parentDom = document.head || document.body;
        parentDom.appendChild(preloadLink);
    });
};
/**
 * @airwallex/components-sdk may run in node environment, e.g., in Next.js
 * Prefetch scripts only in browser environment
 */
var isNode = typeof document === 'undefined' || typeof window === 'undefined';
if (!isNode) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', prefetchScripts);
    }
    else {
        prefetchScripts();
    }
}

if (typeof window !== 'undefined') {
    if (!window.AirwallexComponentsSDK) {
        Object.defineProperties(window, {
            AirwallexComponentsSDK: {
                value: {},
                writable: false
            },
            _AirwallexSDKs: {
                value: {},
                writable: false
            }
        });
    }
    window.AirwallexComponentsSDK.init = init;
    window.AirwallexComponentsSDK.createElement = createElement;
}




/***/ }),

/***/ 638:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export AirTrackerPlugin */
/* unused harmony export AutoDetectedEventType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Environment; });
/* unused harmony export NetworkType */
/* unused harmony export SeverityType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return src_default; });
// src/constant/common.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var SeverityType = /* @__PURE__ */ function(SeverityType2) {
    SeverityType2["VERBOSE"] = "verbose";
    SeverityType2["ERROR"] = "error";
    SeverityType2["WARN"] = "warn";
    SeverityType2["INFO"] = "info";
    SeverityType2["HTTP"] = "http";
    SeverityType2["AUTO_DETECT_ERROR"] = "autoDetectError";
    SeverityType2["PERFORMANCE"] = "performance";
    SeverityType2["SPEED"] = "speed";
    SeverityType2["AUTO_DETECT_EVENT"] = "autoDetectEvent";
    return SeverityType2;
}(SeverityType || {});
var Environment = /* @__PURE__ */ function(Environment2) {
    Environment2["production"] = "prod";
    Environment2["demo"] = "demo";
    Environment2["staging"] = "staging";
    return Environment2;
}(Environment || {});
var NetworkType = /* @__PURE__ */ function(NetworkType2) {
    NetworkType2["unknown"] = "unknown";
    NetworkType2["wifi"] = "wifi";
    NetworkType2["net2g"] = "net2g";
    NetworkType2["net3g"] = "net3g";
    NetworkType2["net4g"] = "net4g";
    NetworkType2["net5g"] = "net5g";
    return NetworkType2;
}(NetworkType || {});
var AutoDetectedEventType = /* @__PURE__ */ function(AutoDetectedEventType2) {
    AutoDetectedEventType2["onPageChange"] = "onPageChange";
    AutoDetectedEventType2["onPageRetention"] = "onPageRetention";
    AutoDetectedEventType2["httpClientMetrics"] = "httpClientMetrics";
    return AutoDetectedEventType2;
}(AutoDetectedEventType || {});
// src/constant/config.ts
var UNKNOWN_VALUE = "airTracker_unknown";
var DEFAULT_CONFIG = {
    appName: UNKNOWN_VALUE,
    appVersion: UNKNOWN_VALUE,
    env: "staging" /* staging */ ,
    isWebappContainer: false,
    delay: 2e3,
    errorRepeatTime: 3,
    enableErrorMonitoring: false,
    assetSpeedMonitoringWhiteList: [],
    enableDetectPageChange: false,
    enableRecordPageRetention: false,
    hideSearchParams: false,
    useSessionStorageForSessionId: false,
    assetSpeedMonitoringWhiteListByMFE: {}
};
var DEFAULT_COMMON_DATA = {
    appName: UNKNOWN_VALUE,
    env: "staging" /* staging */ ,
    sessionId: UNKNOWN_VALUE,
    deviceId: UNKNOWN_VALUE
};
// src/util/jsonHelper.ts
var isJSON = function(str) {
    if (!str) {
        return false;
    }
    if (/^\s*$/.test(str)) return false;
    str = str.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@");
    str = str.replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]");
    str = str.replace(/(?:^|:|,)(?:\s*\[)+/g, "");
    return /^[\],:{}\s]*$/.test(str);
};
var safeReplacer = function() {
    var seen = /* @__PURE__ */ new WeakSet();
    return function(key, value) {
        if (_instanceof(value, Error)) {
            return "Error.message: ".concat(value.message, " \n  Error.stack: ").concat(value.stack);
        }
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && value !== null) {
            if (seen.has(value)) {
                return "[Circular ".concat(key || "root", "]");
            }
            seen.add(value);
        }
        if (typeof value === "function") {
            return "function";
        }
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "symbol") {
            return "symbol";
        }
        if (typeof value === "undefined") {
            return null;
        }
        return value;
    };
};
var safeStringify = function(obj) {
    if (typeof obj === "string") {
        return obj;
    }
    try {
        if (_instanceof(obj, Error)) {
            return (JSON.stringify(obj, safeReplacer()) || "undefined").replace(/"/gim, "");
        }
        return JSON.stringify(obj, safeReplacer());
    } catch (e) {
        return '{"error":"error happen when airTracker stringify"}';
    }
};
// src/util/http.ts
var request = function(param) {
    var _param_method = param.method, method = _param_method === void 0 ? "post" : _param_method, url = param.url, data = param.data, success = param.success, fail = param.fail;
    if (!isJSON(data)) {
        return;
    }
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function() {
        if (xhr.readyState === 4) {
            if (xhr.status >= 400 || xhr.status === 0) {
                fail === null || fail === void 0 ? void 0 : fail(xhr.response);
            } else {
                success === null || success === void 0 ? void 0 : success(xhr.response);
            }
        }
    });
    xhr.open(method, url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(data);
};
// src/constant/lifeCycleEventName.ts
var lifeCycleEventName = {
    onInit: "onInit",
    onConfigInit: "onConfigInit",
    onConfigUpdated: "onConfigUpdated",
    onCommonDataInit: "onCommonDataInit",
    onCommonUpdated: "onCommonUpdated",
    onPageChange: "onPageChange",
    onDestroy: "onDestroy,"
};
// src/constant/index.ts
var DEVICE_ID_STORAGE_KEY = "AIR_ANALYTICS_DEVICE_ID";
var SESSION_ID_STORAGE_KEY = "AIR_ANALYTICS_SESSION_ID";
var RISK_DEVICE_ID_STORAGE_KEY = "AWX_RISK_ID";
var loggingServiceUrl = function(env) {
    if (env == "prod" /* production */ ) {
        return "https://o11y.airwallex.com/airtracker/logs";
    }
    if (env == "demo" /* demo */ ) {
        return "https://o11y-demo.airwallex.com/airtracker/logs";
    }
    return "https://o11y-staging.airwallex.com/airtracker/logs";
};
var loggingServiceMetricsUrl = function(env) {
    if (env == "prod" /* production */ ) {
        return "https://o11y.airwallex.com/airtracker/metrics";
    }
    if (env == "demo" /* demo */ ) {
        return "https://o11y-demo.airwallex.com/airtracker/metrics";
    }
    return "https://o11y-staging.airwallex.com/airtracker/metrics";
};
// src/util/index.ts
var generateUId = function() {
    var deviceId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 3 | 8;
        return v.toString(16);
    });
    return deviceId;
};
var getMFEName = function(airTracker2) {
    var _location_pathname_split, _location_pathname, _location;
    if (airTracker2.config.getMFEName) {
        return airTracker2.config.getMFEName();
    }
    return ((_location = location) === null || _location === void 0 ? void 0 : (_location_pathname = _location.pathname) === null || _location_pathname === void 0 ? void 0 : (_location_pathname_split = _location_pathname.split("/")) === null || _location_pathname_split === void 0 ? void 0 : _location_pathname_split[2]) || "unknown";
};
var getSessionId = function() {
    try {
        var sessionId = window.sessionStorage.getItem(SESSION_ID_STORAGE_KEY);
        if (!sessionId) {
            sessionId = generateUId();
            window.sessionStorage.setItem(SESSION_ID_STORAGE_KEY, sessionId);
        }
        return sessionId;
    } catch (e) {
        return generateUId();
    }
};
var getDeviceId = function() {
    try {
        var deviceId = window.localStorage.getItem(DEVICE_ID_STORAGE_KEY);
        if (!deviceId) {
            deviceId = generateUId();
            window.localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
        }
        return deviceId;
    } catch (e) {}
};
var getRiskDeviceId = function() {
    try {
        var deviceId = window.localStorage.getItem(RISK_DEVICE_ID_STORAGE_KEY);
        return deviceId || void 0;
    } catch (e) {}
};
var getNetworkType = function() {
    var _navigator;
    var netType = "";
    var arr = navigator.userAgent.match(/NetType\/(\w+)/);
    if (arr) {
        var ref;
        ref = _sliced_to_array(arr, 2), netType = ref[1], ref;
    } else if ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.connection) {
        var _navigator_connection, _navigator1, _navigator_connection1, _navigator2;
        netType = ((_navigator1 = navigator) === null || _navigator1 === void 0 ? void 0 : (_navigator_connection = _navigator1.connection) === null || _navigator_connection === void 0 ? void 0 : _navigator_connection.effectiveType) || ((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : (_navigator_connection1 = _navigator2.connection) === null || _navigator_connection1 === void 0 ? void 0 : _navigator_connection1.type);
    }
    if (!netType) {
        netType = "unknown";
    }
    return parseNetType(netType);
};
var parseNetType = function(net) {
    net = String(net).toLowerCase();
    if (net.indexOf("4g") >= 0) return "net4g" /* net4g */ ;
    if (net.indexOf("wifi") >= 0) return "wifi" /* wifi */ ;
    if (net.indexOf("5g") >= 0) return "net5g" /* net5g */ ;
    if (net.indexOf("3g") >= 0) return "net3g" /* net3g */ ;
    if (net.indexOf("2g") >= 0) return "net2g" /* net2g */ ;
    return "unknown" /* unknown */ ;
};
var canUseResourceTiming = function canUseResourceTiming() {
    return typeof window.performance !== "undefined" && typeof window.performance.clearResourceTimings === "function" && typeof window.performance.getEntriesByType === "function" && typeof window.performance.now === "function";
};
var formatUrl = function(url) {
    if (typeof url === "string") {
        var hostUrl = url.split("?")[0] || "";
        return hostUrl.slice(0, 200);
    }
    return url;
};
var getQueryString = function(url) {
    if (typeof url === "string") {
        return url.split("?")[1] || "";
    }
    return url;
};
var urlIsHttps = function(url) {
    var isHostProtocol = typeof url === "string" && url.startsWith("//");
    return isHostProtocol ? typeof location !== "undefined" && location.protocol === "https:" : /^https/.test(url);
};
var getReportVal = function(rawVal, isDefaultByString) {
    if (typeof rawVal === "number") {
        return rawVal;
    }
    if (typeof rawVal === "string") {
        return rawVal;
    }
    return isDefaultByString ? "" /* string */  : -1 /* number */ ;
};
var checkIfInWhiteList = function(url, airTracker2) {
    var _airTracker2_config_assetSpeedMonitoringWhiteListByMFE;
    var isInWhiteList = false;
    if (!airTracker2.config.isWebappContainer) {
        isInWhiteList = checkIfInWhiteListHelper(url, airTracker2.config.assetSpeedMonitoringWhiteList);
        return isInWhiteList;
    }
    var MFEName = getMFEName(airTracker2);
    return isInWhiteList || checkIfInWhiteListHelper(url, (_airTracker2_config_assetSpeedMonitoringWhiteListByMFE = airTracker2.config.assetSpeedMonitoringWhiteListByMFE) === null || _airTracker2_config_assetSpeedMonitoringWhiteListByMFE === void 0 ? void 0 : _airTracker2_config_assetSpeedMonitoringWhiteListByMFE[MFEName]);
};
var checkIfInWhiteListHelper = function(url, whiteList) {
    if (!(whiteList === null || whiteList === void 0 ? void 0 : whiteList.length)) {
        return false;
    }
    for(var i = 0; i < whiteList.length; i++){
        var cur = whiteList[i];
        if (_instanceof(cur, RegExp) && cur.test(url)) {
            return true;
        }
        if (typeof cur == "string" && url.includes(cur)) {
            return true;
        }
    }
    return false;
};
var roundSubtract = function(a, b) {
    var precision = 100;
    return Math.round((a - b) * precision) / precision;
};
// src/pipes/send.ts
var sendNormalLogPipe = function(airTracker2) {
    return function(logs) {
        var _airTracker2_MFECommonDataMap, _navigator;
        var MFEName = getMFEName(airTracker2);
        var commonData = airTracker2.config.isWebappContainer ? _object_spread({}, airTracker2.commonData || {}, ((_airTracker2_MFECommonDataMap = airTracker2.MFECommonDataMap) === null || _airTracker2_MFECommonDataMap === void 0 ? void 0 : _airTracker2_MFECommonDataMap[MFEName]) || {}) : airTracker2.commonData;
        var data = Array.isArray(logs) ? logs : [
            logs
        ];
        if (data.length === 0) {
            return;
        }
        var finalLog = {
            commonData: commonData,
            data: data
        };
        var dataBody = safeStringify(finalLog);
        var sendOptions = {
            method: "post",
            url: loggingServiceUrl(airTracker2.commonData.env),
            data: dataBody
        };
        if (typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon) === "function") {
            var success = navigator.sendBeacon(sendOptions.url, dataBody);
            if (!success) {
                request(sendOptions);
            }
        } else {
            request(sendOptions);
        }
    };
};
var sendMetricsLogPipe = function(airTracker2) {
    return function(logs) {
        var _airTracker2_MFECommonDataMap, _navigator;
        var MFEName = getMFEName(airTracker2);
        var commonData = airTracker2.config.isWebappContainer ? _object_spread({}, airTracker2.commonData || {}, ((_airTracker2_MFECommonDataMap = airTracker2.MFECommonDataMap) === null || _airTracker2_MFECommonDataMap === void 0 ? void 0 : _airTracker2_MFECommonDataMap[MFEName]) || {}) : airTracker2.commonData;
        var finalLog = {
            commonData: commonData,
            data: Array.isArray(logs) ? logs : [
                logs
            ]
        };
        var dataBody = safeStringify(finalLog);
        var sendOptions = {
            method: "post",
            url: loggingServiceMetricsUrl(airTracker2.commonData.env),
            data: dataBody
        };
        if (typeof ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.sendBeacon) === "function") {
            var success = navigator.sendBeacon(sendOptions.url, dataBody);
            if (!success) {
                request(sendOptions);
            }
        } else {
            request(sendOptions);
        }
    };
};
// src/pipes/throttle.ts
var throttlePipe = function(airTracker2, maxLength) {
    var timer;
    var retainedLogs = [];
    var config = airTracker2.config;
    window.addEventListener("beforeunload", function() {
        if (retainedLogs.length > 0) {
            airTracker2.immediateSendPipe(retainedLogs.splice(0, retainedLogs.length));
            timer && clearTimeout(timer);
        }
    });
    return function(log, resolve) {
        retainedLogs.push(log);
        airTracker2.lifeCycle.on(lifeCycleEventName.onCommonUpdated, function() {
            if (retainedLogs.length > 0) {
                resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
                airTracker2.lifeCycle.remove(lifeCycleEventName.onCommonUpdated);
                timer && clearTimeout(timer);
            }
        });
        if (maxLength && retainedLogs.length >= maxLength) {
            resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
            timer && clearTimeout(timer);
            return;
        }
        timer && clearTimeout(timer);
        timer = setTimeout(function() {
            timer = null;
            if (retainedLogs.length > 0) {
                resolve === null || resolve === void 0 ? void 0 : resolve(retainedLogs.splice(0, retainedLogs.length));
                airTracker2.lifeCycle.remove(lifeCycleEventName.onCommonUpdated);
            }
        }, config.delay);
    };
};
// src/pipes/errorRepeatLimit.ts
var errorLogLimitPipe = function(airTracker2) {
    var errorLogMap = {};
    return function(logs, resolve) {
        var maxNum = typeof airTracker2.config.errorRepeatTime === "number" ? airTracker2.config.errorRepeatTime : 5;
        if (maxNum === 0) {
            return resolve === null || resolve === void 0 ? void 0 : resolve(logs);
        }
        resolve === null || resolve === void 0 ? void 0 : resolve(logs.filter(function(log) {
            if (log.severity == "autoDetectError" /* AUTO_DETECT_ERROR */ ) {
                errorLogMap[log.error] = errorLogMap[log.error] || 0;
                errorLogMap[log.error] += 1;
                if (errorLogMap[log.error] > maxNum) {
                    return false;
                }
                return true;
            }
            return true;
        }));
    };
};
// src/pipes/index.ts
var noop = function() {};
var createPipeline = function(pipeArr) {
    if (!pipeArr || !pipeArr.reduce || !pipeArr.length) {
        throw new TypeError("createPipeline need at least one function param");
    }
    if (pipeArr.length === 1) {
        return function(msg, resolve) {
            pipeArr[0](msg, resolve || noop);
        };
    }
    return pipeArr.reduce(function(prePipe, pipe) {
        return function(msg) {
            var nextPipe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
            return prePipe(msg, function(msg2) {
                return pipe === null || pipe === void 0 ? void 0 : pipe(msg2, nextPipe);
            });
        };
    });
};
// src/util/eventEmitter.ts
var EventEmitter = /*#__PURE__*/ function() {
    "use strict";
    function EventEmitter() {
        var _this = this;
        _class_call_check(this, EventEmitter);
        this.emit = function(name, data) {
            if (!_this) return;
            var events = _this.eventsList[name];
            var handler;
            if (events === null || events === void 0 ? void 0 : events.length) {
                events = events.slice();
                for(var i = 0; i < events.length; i++){
                    handler = events[i];
                    try {
                        var result = handler.callback.apply(_this, [
                            data
                        ]);
                        if (1 === handler.type) {
                            _this.remove(name, handler.callback);
                        }
                        if (false === result) {
                            break;
                        }
                    } catch (e) {
                        throw e;
                    }
                }
            }
            return _this;
        };
        this.eventsList = {};
    }
    _create_class(EventEmitter, [
        {
            key: "indexOf",
            value: function indexOf(array, value) {
                for(var i = 0; i < array.length; i++){
                    if (array[i].callback === value) {
                        return i;
                    }
                }
                return -1;
            }
        },
        {
            key: "on",
            value: function on(name, callback) {
                var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                if (!this) return;
                var events = this.eventsList[name];
                if (!events) {
                    this.eventsList[name] = [];
                    events = this.eventsList[name];
                }
                if (this.indexOf(events, callback) === -1) {
                    var handler = {
                        name: name,
                        type: type || 0,
                        callback: callback
                    };
                    events.push(handler);
                    return this;
                }
                return this;
            }
        },
        {
            key: "one",
            value: function one(name, callback) {
                this.on(name, callback, 1);
            }
        },
        {
            key: "remove",
            value: function remove(name, callback) {
                if (!this) return;
                var events = this.eventsList[name];
                if (!events) {
                    return null;
                }
                if (!callback) {
                    try {
                        delete this.eventsList[name];
                    } catch (e) {}
                    return null;
                }
                if (events.length) {
                    var index = this.indexOf(events, callback);
                    events.splice(index, 1);
                }
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.eventsList = {};
            }
        }
    ]);
    return EventEmitter;
}();
// src/interface/plugins.ts
var AirTrackerPlugin = /*#__PURE__*/ function() {
    "use strict";
    function AirTrackerPlugin(pluginOption) {
        _class_call_check(this, AirTrackerPlugin);
        this.name = "";
        // initiation flag
        this.isInit = false;
        this.name = pluginOption.name;
        this.option = pluginOption;
    }
    _create_class(AirTrackerPlugin, [
        {
            key: "patch",
            value: function patch(airTracker2) {
                if (!this.isInit) {
                    var _this_option_setUp, _this_option;
                    this.isInit = true;
                    (_this_option = this.option) === null || _this_option === void 0 ? void 0 : (_this_option_setUp = _this_option.setUp) === null || _this_option_setUp === void 0 ? void 0 : _this_option_setUp.call(this.option, airTracker2);
                }
            }
        },
        {
            key: "uninstall",
            value: function uninstall() {
                var _this_option_destroy, _this_option;
                (_this_option = this.option) === null || _this_option === void 0 ? void 0 : (_this_option_destroy = _this_option.destroy) === null || _this_option_destroy === void 0 ? void 0 : _this_option_destroy.apply(this);
                this.isInit = false;
            }
        }
    ]);
    return AirTrackerPlugin;
}();
// src/plugins/onErrorPlugin.ts
var airTracker;
var onError = function(event) {
    var errString = "".concat(safeStringify(event.message) || "", " @ (").concat(safeStringify(event.filename) || "", ":").concat(event.lineno || 0, ":").concat(event.colno || 0, ")\n").concat(safeStringify(event.error || ""));
    airTracker.normalLogPipeLine({
        severity: "autoDetectError" /* AUTO_DETECT_ERROR */ ,
        eventName: "windowOnError" /* windowOnError */ ,
        extraInfo: {
            error: errString
        }
    });
};
var unhandledrejectionHandler = function(event) {
    var reason = event && safeStringify(event.reason);
    airTracker.normalLogPipeLine({
        severity: "autoDetectError" /* AUTO_DETECT_ERROR */ ,
        eventName: "promiseError" /* promiseError */ ,
        extraInfo: {
            error: reason
        }
    });
};
var errorHandler = function(event) {
    var target = (event === null || event === void 0 ? void 0 : event.target) || (event === null || event === void 0 ? void 0 : event.srcElement);
    if (!target) {
        return;
    }
    var url = (target === null || target === void 0 ? void 0 : target.src) || (target === null || target === void 0 ? void 0 : target.href);
    var tagName = target.tagName;
    var staticFileType = "unknown" /* unknown */ ;
    if (typeof url === "string" && tagName) {
        if (window.location.href.indexOf(url) > -1) {
            return;
        }
        if (/\.js$/.test(url)) {
            staticFileType = "script" /* script */ ;
        } else if (/\.css$/.test(url)) {
            staticFileType = "css" /* css */ ;
        } else {
            switch(tagName.toLowerCase()){
                case "script":
                    staticFileType = "script" /* script */ ;
                    break;
                case "link":
                    staticFileType = "css" /* css */ ;
                    break;
                case "img":
                    staticFileType = "image" /* img */ ;
                    break;
                case "audio":
                case "video":
                    staticFileType = "media" /* media */ ;
                    break;
                default:
                    return;
            }
        }
        airTracker.normalLogPipeLine({
            severity: "autoDetectError" /* AUTO_DETECT_ERROR */ ,
            eventName: "staticFileLoadError" /* staticFileLoadError */ ,
            extraInfo: {
                staticFileType: staticFileType,
                error: "".concat(tagName, " load fail: ").concat(url)
            }
        });
    }
};
var errorDetectionPlugin = new AirTrackerPlugin({
    name: "errorDetectionPlugin",
    setUp: function(airTrackerInst) {
        airTracker = airTrackerInst;
        window.addEventListener("error", onError);
        window.addEventListener("unhandledrejection", unhandledrejectionHandler);
        window.document.addEventListener("error", errorHandler, true);
    },
    destroy: function() {
        window.removeEventListener("unhandledrejection", unhandledrejectionHandler);
        window.document.removeEventListener("error", errorHandler, true);
        window.removeEventListener("error", onError);
    }
});
// src/plugins/assetsSpeedPlugin.ts
var ASSETS_INITIATOR_TYPE = [
    "img",
    "css",
    "script",
    "link",
    "audio",
    "video",
    "iframe"
];
var COLLECTED_ENTRY_TYPE = "resource";
var generateSpeedLog = function(entry) {
    var resourceURl = entry.name;
    return {
        url: formatUrl(resourceURl),
        method: "get",
        // duration = redirect + DNS + CONNECTION + request + response
        duration: Number(entry.duration.toFixed(2)),
        // time it takes to load
        type: "static",
        isHttps: urlIsHttps(resourceURl),
        urlQuery: getQueryString(resourceURl),
        domainLookup: getReportVal(entry.domainLookupEnd - entry.domainLookupStart),
        connectTime: getReportVal(entry.connectEnd - entry.connectStart)
    };
};
var publishSpeedLogs = function(entries, airTracker2) {
    for(var i = 0, l = entries.length; i < l; i++){
        var entry = entries[i];
        if (ASSETS_INITIATOR_TYPE.indexOf(entry.initiatorType) !== -1 && checkIfInWhiteList(entry.name, airTracker2)) {
            airTracker2.normalLogPipeLine({
                severity: "performance" /* PERFORMANCE */ ,
                eventName: "assets_speed" /* ASSETS_SPEED */ ,
                extraInfo: {
                    log: generateSpeedLog(entry)
                }
            });
        }
    }
};
var interval;
var observer;
var assetSpeedPlugin = new AirTrackerPlugin({
    name: "assetsSpeedPlugin",
    setUp: function(airTracker2) {
        if (!canUseResourceTiming()) return;
        var collectCur = 0;
        window.performance.onresourcetimingbufferfull = function() {
            collectCur = 0;
            window.performance.clearResourceTimings();
        };
        if (typeof window.PerformanceObserver === "function") {
            publishSpeedLogs(window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE), airTracker2);
            observer = new window.PerformanceObserver(function(list) {
                publishSpeedLogs(list.getEntries(), airTracker2);
            });
            observer.observe({
                entryTypes: [
                    COLLECTED_ENTRY_TYPE
                ]
            });
        } else {
            interval = setInterval(function() {
                var allEntries = window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE);
                var collectEntries = allEntries.slice(collectCur);
                collectCur = allEntries.length;
                publishSpeedLogs(collectEntries, airTracker2);
            }, 3e3);
        }
    },
    destroy: function() {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        interval && clearInterval(interval);
    }
});
// src/plugins/onPageChangePlugin.ts
var observer2;
var onPageChangePlugin = new AirTrackerPlugin({
    name: "onPageChangePlugin",
    setUp: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(airTracker2) {
            var _location, previousUrl, body, sendOnPageChangeEvent, config;
            return _ts_generator(this, function(_state) {
                previousUrl = (_location = location) === null || _location === void 0 ? void 0 : _location.href;
                body = document.querySelector("body");
                sendOnPageChangeEvent = function(param) {
                    var prevHref = param.prevHref;
                    var _location, _location1, _location2, _location3, _location4;
                    airTracker2.normalLogPipeLine({
                        severity: "autoDetectEvent" /* AUTO_DETECT_EVENT */ ,
                        eventName: "onPageChange" /* onPageChange */ ,
                        extraInfo: {
                            prevHref: prevHref,
                            href: ((_location = location) === null || _location === void 0 ? void 0 : _location.href) || "",
                            hostname: (_location1 = location) === null || _location1 === void 0 ? void 0 : _location1.hostname,
                            pathName: (_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.pathname,
                            protocol: (_location3 = location) === null || _location3 === void 0 ? void 0 : _location3.protocol,
                            search: (_location4 = location) === null || _location4 === void 0 ? void 0 : _location4.search
                        }
                    });
                };
                sendOnPageChangeEvent({
                    prevHref: ""
                });
                observer2 = new MutationObserver(function() {
                    if (location.href !== previousUrl) {
                        var tempPreviousUrl = previousUrl;
                        previousUrl = location.href;
                        sendOnPageChangeEvent({
                            prevHref: tempPreviousUrl
                        });
                    }
                });
                config = {
                    subtree: true,
                    childList: true
                };
                observer2.observe(body || document, config);
                return [
                    2
                ];
            });
        });
        return function(airTracker2) {
            return _ref.apply(this, arguments);
        };
    }(),
    destroy: function() {
        observer2 === null || observer2 === void 0 ? void 0 : observer2.disconnect();
    }
});
// src/plugins/pageRetentionPlugin.ts
var observer3;
var onPageRetentionPlugin = new AirTrackerPlugin({
    name: "onPageRetentionPlugin",
    setUp: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(airTracker2) {
            var _location, previousUrl, body, enterPageTimeStamp, startRecording, sendPageRetentionEvent, config;
            return _ts_generator(this, function(_state) {
                if (typeof document.visibilityState === "undefined") {
                    return [
                        2
                    ];
                }
                previousUrl = (_location = location) === null || _location === void 0 ? void 0 : _location.href;
                body = document.querySelector("body");
                startRecording = function() {
                    enterPageTimeStamp = Date.now();
                };
                startRecording();
                document.addEventListener("visibilitychange", function() {
                    if (document.visibilityState === "hidden") {
                        sendPageRetentionEvent({
                            href: location.href,
                            leftReason: "visibilityChange" /* visibilityChange */ 
                        });
                    } else if (document.visibilityState === "visible") {
                        startRecording();
                    }
                });
                window.addEventListener("beforeunload", function() {
                    sendPageRetentionEvent({
                        href: location.href,
                        sendImmediate: true,
                        leftReason: "pageClose" /* pageClose */ 
                    });
                });
                sendPageRetentionEvent = function(param) {
                    var href = param.href, sendImmediate = param.sendImmediate, leftReason = param.leftReason;
                    if (!enterPageTimeStamp) {
                        return;
                    }
                    var duration = Date.now() - enterPageTimeStamp;
                    if (duration === 0) {
                        return;
                    }
                    enterPageTimeStamp = void 0;
                    var payload = {
                        severity: "autoDetectEvent" /* AUTO_DETECT_EVENT */ ,
                        eventName: "onPageRetention" /* onPageRetention */ ,
                        extraInfo: {
                            href: href,
                            duration: duration,
                            leftReason: leftReason
                        }
                    };
                    if (sendImmediate) {
                        airTracker2.ImmediatePipeline(payload);
                        return;
                    }
                    airTracker2.normalLogPipeLine(payload);
                };
                observer3 = new MutationObserver(function() {
                    if (location.href !== previousUrl) {
                        var tempPreviousUrl = previousUrl;
                        previousUrl = location.href;
                        sendPageRetentionEvent({
                            href: tempPreviousUrl,
                            leftReason: "nextPage" /* nextPage */ 
                        });
                        startRecording();
                    }
                });
                config = {
                    subtree: true,
                    childList: true
                };
                observer3.observe(body || document, config);
                return [
                    2
                ];
            });
        });
        return function(airTracker2) {
            return _ref.apply(this, arguments);
        };
    }(),
    destroy: function() {
        observer3 === null || observer3 === void 0 ? void 0 : observer3.disconnect();
    }
});
// src/plugins/apiPerformancePlugin/utils.ts
var generateRandomId = function() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 15);
};
var checkIfInWhiteList2 = function(url, whiteList) {
    var defaultWhiteList = [
        /^https?:\/\/[^\/]*\.airwallex\.com($|\/)/
    ];
    var defaultExclusionList = [
        /authenticate\/heartbeat/,
        /papluginlogs\/.*/,
        /airtracker\/.*/,
        /o11y(-staging|-demo)?\.airwallex\.com/,
        /\.(png|jpe?g|gif|svg|ico|webp|avif|css|js|json|woff2?|ttf|eot|map|txt|csv|xml)(\?.*)?(#.*)?$/i
    ];
    if (defaultExclusionList.some(function(item) {
        return item.test(url);
    })) {
        return false;
    }
    return checkIfInWhiteListHelper(url, whiteList || defaultWhiteList);
};
var findMainEntry = function(performanceItem) {
    var startTime = performanceItem.startTime, endTime = performanceItem.endTime, entries = performanceItem.entries;
    if (entries.length === 0) {
        return void 0;
    }
    if (entries.length === 1) {
        return entries[0];
    }
    var filteredEntries = entries.filter(function(entry) {
        return entry.startTime >= startTime && endTime && entry.responseEnd <= endTime;
    }).sort(function(a, b) {
        return a.startTime - b.startTime;
    });
    return filteredEntries === null || filteredEntries === void 0 ? void 0 : filteredEntries[0];
};
var round2Decimal = function(value) {
    return Math.round(value * 100) / 100;
};
var processPerformanceEntry = function(entry) {
    var startTime = entry.startTime, duration = entry.duration, responseStart = entry.responseStart, connectEnd = entry.connectEnd, connectStart = entry.connectStart, domainLookupEnd = entry.domainLookupEnd, domainLookupStart = entry.domainLookupStart, requestStart = entry.requestStart, secureConnectionStart = entry.secureConnectionStart, redirectEnd = entry.redirectEnd, redirectStart = entry.redirectStart, responseStatus = entry.responseStatus, responseEnd = entry.responseEnd, encodedBodySize = entry.encodedBodySize, decodedBodySize = entry.decodedBodySize, transferSize = entry.transferSize, deliveryType = entry.deliveryType, initiatorType = entry.initiatorType;
    return {
        startTime: round2Decimal(startTime),
        totalDuration: round2Decimal(duration),
        timeToFirstByte: roundSubtract(responseStart, startTime),
        tcpDuration: roundSubtract(connectEnd, connectStart),
        dnsDuration: roundSubtract(domainLookupEnd, domainLookupStart),
        tlsDuration: roundSubtract(requestStart, secureConnectionStart),
        redirectDuration: roundSubtract(redirectEnd, redirectStart),
        responseDuration: roundSubtract(responseEnd, responseStart),
        encodeResponseSize: encodedBodySize,
        decodeResponseSize: decodedBodySize,
        transferSize: transferSize,
        deliveryType: deliveryType,
        statusCode: responseStatus,
        initiatorType: initiatorType
    };
};
var getPayload = function(performanceItem, extraInfo) {
    var url = performanceItem.url, method = performanceItem.method, errorType = performanceItem.errorType, errorDetail = performanceItem.errorDetail;
    var mainEntry = findMainEntry(performanceItem);
    var _ref = new URL(url, window.location.href), href = _ref.href, protocol = _ref.protocol;
    var payloadFromPerformanceEntry = mainEntry ? processPerformanceEntry(mainEntry) : {};
    var payload = {
        severity: "autoDetectEvent" /* AUTO_DETECT_EVENT */ ,
        eventName: "httpClientMetrics" /* httpClientMetrics */ ,
        extraInfo: _object_spread(_object_spread_props(_object_spread({
            httpUrl: href,
            method: method,
            scheme: protocol
        }, errorType && {
            errorType: errorType
        }, errorDetail && {
            errorDetail: errorDetail
        }, payloadFromPerformanceEntry), {
            // use injected response as fallback
            statusCode: (payloadFromPerformanceEntry === null || payloadFromPerformanceEntry === void 0 ? void 0 : payloadFromPerformanceEntry.statusCode) || (performanceItem === null || performanceItem === void 0 ? void 0 : performanceItem.responseStatus),
            startTime: (payloadFromPerformanceEntry === null || payloadFromPerformanceEntry === void 0 ? void 0 : payloadFromPerformanceEntry.startTime) || (performanceItem === null || performanceItem === void 0 ? void 0 : performanceItem.startTime),
            initiatorType: (payloadFromPerformanceEntry === null || payloadFromPerformanceEntry === void 0 ? void 0 : payloadFromPerformanceEntry.initiatorType) || (performanceItem === null || performanceItem === void 0 ? void 0 : performanceItem.initiatorType)
        }), extraInfo)
    };
    return payload;
};
var isGraphQLError = function(responseBody) {
    return(// Has data or errors at root level
    responseBody && (typeof responseBody === "undefined" ? "undefined" : _type_of(responseBody)) === "object" && "errors" in responseBody && // If errors exist, they should be an array with proper GraphQL error shape
    Array.isArray(responseBody.errors) && responseBody.errors.every(function(error) {
        return error && (typeof error === "undefined" ? "undefined" : _type_of(error)) === "object" && "message" in error;
    }));
};
// src/plugins/apiPerformancePlugin/type.ts
var API_PERFORMANCE_QUEUE = "awx_airtracker_api_performance_queue";
var API_PERFORMANCE_PLUGIN_LOADED = "awx_airtracker_api_performance_plugin_loaded";
// src/plugins/apiPerformancePlugin/index.ts
var OBSERVER_WAIT_TIME_MS = 300;
var TIMEOUT_WAIT_TIME_MS = 1e4;
var globalObject = typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {};
globalObject[API_PERFORMANCE_QUEUE] = globalObject[API_PERFORMANCE_QUEUE] || [];
var handlePayloadAndSendLog = function(apiPerformanceItem, airTracker2, extraInfo) {
    setTimeout(function() {
        var payload = getPayload(apiPerformanceItem, extraInfo);
        airTracker2.observerPipeline(payload);
        globalObject[API_PERFORMANCE_QUEUE] = globalObject[API_PERFORMANCE_QUEUE].filter(function(item) {
            return item.id !== apiPerformanceItem.id;
        });
    }, OBSERVER_WAIT_TIME_MS);
};
var handleTimeout = function(requestId, airTracker2) {
    setTimeout(function() {
        var matchedApiPerformanceItem = globalObject[API_PERFORMANCE_QUEUE].find(function(item) {
            return item.id === requestId;
        });
        if (!matchedApiPerformanceItem) {
            return;
        }
        var payload = getPayload(matchedApiPerformanceItem, {
            exceptionType: "timeout-without-response"
        });
        airTracker2.observerPipeline(payload);
        globalObject[API_PERFORMANCE_QUEUE] = globalObject[API_PERFORMANCE_QUEUE].filter(function(item) {
            return item.id !== requestId;
        });
    }, TIMEOUT_WAIT_TIME_MS);
};
var injectXMLHttpRequest = function(airTracker2) {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function injectXMLHttpRequest(method, url, async, username, password) {
        try {
            var _airTracker2_config;
            var requestId = generateRandomId();
            this.__requestId = requestId;
            var urlString = _instanceof(url, URL) ? url.href : new URL(url, window.location.href).href;
            if (!checkIfInWhiteList2(urlString, (_airTracker2_config = airTracker2.config) === null || _airTracker2_config === void 0 ? void 0 : _airTracker2_config.enableRecordAPIPerformanceWhitelist)) {
                return originalOpen.call(this, method, url, async !== null && async !== void 0 ? async : true, username, password);
            }
            var apiPerformanceItem = {
                id: requestId,
                startTime: performance.now(),
                method: method,
                url: urlString,
                entries: [],
                initiatorType: "xmlhttprequest"
            };
            globalObject[API_PERFORMANCE_QUEUE].push(apiPerformanceItem);
            handleTimeout(requestId, airTracker2);
            return originalOpen.call(this, method, url, async !== null && async !== void 0 ? async : true, username, password);
        } catch (error) {
            airTracker2.normalLogPipeLine({
                severity: "warn" /* WARN */ ,
                eventName: "apiPerformancePluginError",
                extraInfo: {
                    message: "Inject XHR open error",
                    error: error
                }
            });
            return originalOpen.call(this, method, url, async !== null && async !== void 0 ? async : true, username, password);
        }
    };
    XMLHttpRequest.prototype.send = function sendXHRRequest() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        try {
            var matchedApiPerformanceItem = globalObject[API_PERFORMANCE_QUEUE].find(function(item) {
                return item.id === _this.__requestId;
            });
            if (!matchedApiPerformanceItem) {
                return originalSend.apply(this, args);
            }
            var _this1 = this;
            this.addEventListener("loadend", /*#__PURE__*/ _async_to_generator(function() {
                var endTime, duration, status, responseBody, blob, parsedBody, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            endTime = performance.now();
                            duration = endTime - matchedApiPerformanceItem.startTime;
                            status = _this1.status;
                            if (status === 0) {
                                return [
                                    2
                                ];
                            }
                            matchedApiPerformanceItem.endTime = endTime;
                            matchedApiPerformanceItem.duration = duration;
                            matchedApiPerformanceItem.responseStatus = status;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                6,
                                ,
                                7
                            ]);
                            if (!(_this1.responseType === "" || _this1.responseType === "text")) return [
                                3,
                                2
                            ];
                            responseBody = _this1.responseText;
                            return [
                                3,
                                5
                            ];
                        case 2:
                            if (!(_this1.responseType === "json")) return [
                                3,
                                3
                            ];
                            responseBody = _this1.response;
                            return [
                                3,
                                5
                            ];
                        case 3:
                            if (!(_this1.responseType === "blob")) return [
                                3,
                                5
                            ];
                            blob = _this1.response;
                            if (!((blob === null || blob === void 0 ? void 0 : blob.type) === "application/json")) return [
                                3,
                                5
                            ];
                            return [
                                4,
                                blob.text()
                            ];
                        case 4:
                            responseBody = _state.sent();
                            _state.label = 5;
                        case 5:
                            parsedBody = responseBody && typeof responseBody === "string" ? JSON.parse(responseBody) : responseBody;
                            if (parsedBody && isGraphQLError(parsedBody)) {
                                matchedApiPerformanceItem.errorType = "graphqlError";
                                matchedApiPerformanceItem.errorDetail = parsedBody.errors;
                            }
                            return [
                                3,
                                7
                            ];
                        case 6:
                            e = _state.sent();
                            airTracker2.normalLogPipeLine({
                                severity: "warn" /* WARN */ ,
                                eventName: "apiPerformancePluginError",
                                extraInfo: {
                                    message: "Parse response body error in XHR",
                                    url: matchedApiPerformanceItem === null || matchedApiPerformanceItem === void 0 ? void 0 : matchedApiPerformanceItem.url,
                                    error: e
                                }
                            });
                            return [
                                3,
                                7
                            ];
                        case 7:
                            handlePayloadAndSendLog(matchedApiPerformanceItem, airTracker2);
                            return [
                                2
                            ];
                    }
                });
            }));
            this.addEventListener("error", function() {
                handlePayloadAndSendLog(matchedApiPerformanceItem, airTracker2, {
                    exceptionType: "network-error"
                });
            });
            this.addEventListener("abort", function() {
                handlePayloadAndSendLog(matchedApiPerformanceItem, airTracker2, {
                    exceptionType: "abort-error"
                });
            });
            this.addEventListener("timeout", function() {
                handlePayloadAndSendLog(matchedApiPerformanceItem, airTracker2, {
                    exceptionType: "timeout-error"
                });
            });
            return originalSend.apply(this, args);
        } catch (error) {
            airTracker2.normalLogPipeLine({
                severity: "warn" /* WARN */ ,
                eventName: "apiPerformancePluginError",
                extraInfo: {
                    message: "InjectXHR send error",
                    error: error
                }
            });
            throw error;
        }
    };
};
var injectFetch = function(airTracker2) {
    var originalFetch = window.fetch;
    window.fetch = /*#__PURE__*/ _async_to_generator(function() {
        var _len, args, _key, _airTracker2_config, apiPerformanceItem, url, _this, startTime, id, response, endTime, clonedResponse, responseBody, error, error1, exceptionType;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _arguments[_key];
                    }
                    url = new URL(_instanceof(args[0], Request) ? args[0].url : String(args[0]), window.location.href).href;
                    if (!!checkIfInWhiteList2(url, (_airTracker2_config = airTracker2.config) === null || _airTracker2_config === void 0 ? void 0 : _airTracker2_config.enableRecordAPIPerformanceWhitelist)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        originalFetch.apply(this, args)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _state.trys.push([
                        2,
                        9,
                        ,
                        10
                    ]);
                    startTime = performance.now();
                    id = generateRandomId();
                    apiPerformanceItem = {
                        id: id,
                        startTime: startTime,
                        method: ((_this = _instanceof(args[0], Request) ? args[0] : args[1]) === null || _this === void 0 ? void 0 : _this.method) || "GET",
                        url: url,
                        entries: [],
                        initiatorType: "fetch"
                    };
                    globalObject[API_PERFORMANCE_QUEUE].push(apiPerformanceItem);
                    handleTimeout(id, airTracker2);
                    return [
                        4,
                        originalFetch.apply(this, args)
                    ];
                case 3:
                    response = _state.sent();
                    endTime = performance.now();
                    apiPerformanceItem.endTime = endTime;
                    apiPerformanceItem.duration = endTime - startTime;
                    apiPerformanceItem.responseStatus = response.status;
                    clonedResponse = response.clone();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        7,
                        ,
                        8
                    ]);
                    if (!clonedResponse.ok) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        clonedResponse.json()
                    ];
                case 5:
                    responseBody = _state.sent();
                    if (responseBody && isGraphQLError(responseBody)) {
                        apiPerformanceItem.errorType = "graphqlError";
                        apiPerformanceItem.errorDetail = responseBody.errors;
                    }
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        8
                    ];
                case 7:
                    error = _state.sent();
                    airTracker2.normalLogPipeLine({
                        severity: "warn" /* WARN */ ,
                        eventName: "apiPerformancePluginError",
                        extraInfo: {
                            message: "Parse response body error in fetch",
                            url: apiPerformanceItem === null || apiPerformanceItem === void 0 ? void 0 : apiPerformanceItem.url,
                            error: error
                        }
                    });
                    return [
                        3,
                        8
                    ];
                case 8:
                    handlePayloadAndSendLog(apiPerformanceItem, airTracker2);
                    return [
                        2,
                        response
                    ];
                case 9:
                    error1 = _state.sent();
                    if (apiPerformanceItem && apiPerformanceItem.id && globalObject[API_PERFORMANCE_QUEUE].find(function(item) {
                        return item.id === (apiPerformanceItem === null || apiPerformanceItem === void 0 ? void 0 : apiPerformanceItem.id);
                    })) {
                        exceptionType = "fetch-error";
                        if (_instanceof(error1, TypeError)) {
                            exceptionType = "network-error";
                        } else if (_instanceof(error1, DOMException) && error1.name === "AbortError") {
                            exceptionType = "abort-error";
                        }
                        handlePayloadAndSendLog(apiPerformanceItem, airTracker2, {
                            exceptionType: exceptionType
                        });
                    } else {
                        airTracker2.normalLogPipeLine({
                            severity: "warn" /* WARN */ ,
                            eventName: "apiPerformancePluginError",
                            extraInfo: {
                                message: "Inject fetch error",
                                error: error1
                            }
                        });
                    }
                    throw error1;
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
};
var setUpAPIPerformancePlugin = function(airTracker2) {
    var _window;
    injectXMLHttpRequest(airTracker2);
    injectFetch(airTracker2);
    if ((_window = window) === null || _window === void 0 ? void 0 : _window.PerformanceObserver) {
        var observer4 = new window.PerformanceObserver(function(list) {
            var entries = list.getEntries();
            entries.forEach(function(entry) {
                var resourceEntry = entry;
                if (resourceEntry.initiatorType === "fetch" || resourceEntry.initiatorType === "xmlhttprequest") {
                    var items = globalObject[API_PERFORMANCE_QUEUE].filter(function(item) {
                        return item.url === resourceEntry.name;
                    });
                    items.forEach(function(item) {
                        item.entries.push(resourceEntry);
                    });
                }
            });
        });
        observer4.observe({
            entryTypes: [
                "resource"
            ],
            buffered: true
        });
    } else {
        airTracker2.normalLogPipeLine({
            severity: "warn" /* WARN */ ,
            eventName: "apiPerformancePluginError",
            extraInfo: {
                error: "PerformanceObserver Not Supported"
            }
        });
    }
};
var apiPerformancePlugin = new AirTrackerPlugin({
    name: "apiPerformancePlugin",
    setUp: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(airTracker2) {
            var _airTracker2_config, _airTracker2_config1;
            return _ts_generator(this, function(_state) {
                if (globalObject[API_PERFORMANCE_PLUGIN_LOADED]) {
                    return [
                        2
                    ];
                }
                if (((_airTracker2_config = airTracker2.config) === null || _airTracker2_config === void 0 ? void 0 : _airTracker2_config.enableRecordAPIPerformance) && Math.random() < (((_airTracker2_config1 = airTracker2.config) === null || _airTracker2_config1 === void 0 ? void 0 : _airTracker2_config1.enableRecordAPIPerformancePercentage) || 0)) {
                    globalObject[API_PERFORMANCE_PLUGIN_LOADED] = true;
                    setUpAPIPerformancePlugin(airTracker2);
                }
                return [
                    2
                ];
            });
        });
        return function(airTracker2) {
            return _ref.apply(this, arguments);
        };
    }()
});
// src/util/version.ts
var SDK_VERSION = "3.1.0";
// src/airTracker.ts
var AirTracker = /*#__PURE__*/ function() {
    "use strict";
    function AirTracker(param) {
        var _this = this;
        var config = param.config, _param_plugins = param.plugins, plugins = _param_plugins === void 0 ? [] : _param_plugins;
        _class_call_check(this, AirTracker);
        this.config = DEFAULT_CONFIG;
        this.lifeCycle = new EventEmitter();
        this.plugins = [];
        this._commonData = DEFAULT_COMMON_DATA;
        this._MFECommonDataMap = {};
        // customized speed log
        this.timeMap = {};
        this.packedDataConvert = function(param) {
            var severity = param.severity, eventName = param.eventName, extraInfo = param.extraInfo;
            var _location, _location1;
            var packedData = _object_spread({
                severity: severity,
                eventName: eventName,
                currentHref: _this.config.hideSearchParams ? (((_location = location) === null || _location === void 0 ? void 0 : _location.href) || "").split("?")[0] || "" : ((_location1 = location) === null || _location1 === void 0 ? void 0 : _location1.href) || ""
            }, extraInfo);
            if (_this.config.isWebappContainer) {
                packedData.MFEName = getMFEName(_this);
            }
            return packedData;
        };
        this.normalPipelineObj = createPipeline([
            throttlePipe(this, 8),
            errorLogLimitPipe(this),
            sendNormalLogPipe(this)
        ]);
        this.observerPipelineObj = createPipeline([
            throttlePipe(this, 8),
            sendMetricsLogPipe(this)
        ]);
        this.immediateSendPipe = sendNormalLogPipe(this);
        this.observerPipeline = function(param) {
            var severity = param.severity, eventName = param.eventName, extraInfo = param.extraInfo;
            var packedData = _this.packedDataConvert({
                severity: severity,
                eventName: eventName,
                extraInfo: extraInfo
            });
            return _this.observerPipelineObj(packedData);
        };
        this.normalLogPipeLine = function(param) {
            var severity = param.severity, eventName = param.eventName, extraInfo = param.extraInfo;
            var packedData = _this.packedDataConvert({
                severity: severity,
                eventName: eventName,
                extraInfo: extraInfo
            });
            if (_this.config.disableThrottle) {
                return _this.immediateSendPipe(packedData);
            } else {
                return _this.normalPipelineObj(packedData);
            }
        };
        this.ImmediatePipeline = function(param) {
            var severity = param.severity, eventName = param.eventName, extraInfo = param.extraInfo;
            var packedData = _this.packedDataConvert({
                severity: severity,
                eventName: eventName,
                extraInfo: extraInfo
            });
            return _this.immediateSendPipe(packedData);
        };
        this.plugins = _to_consumable_array(plugins);
        this.setConfig(config);
        this.initCommonData(config);
        this.lifeCycle.emit(lifeCycleEventName.onInit);
        if (config.enableErrorMonitoring) {
            this.plugins.push(errorDetectionPlugin);
        }
        if ((config === null || config === void 0 ? void 0 : config.assetSpeedMonitoringWhiteList) && config.assetSpeedMonitoringWhiteList.length > 0 || config.isWebappContainer) {
            this.plugins.push(assetSpeedPlugin);
        }
        if (config === null || config === void 0 ? void 0 : config.enableDetectPageChange) {
            this.plugins.push(onPageChangePlugin);
        }
        if (config === null || config === void 0 ? void 0 : config.enableRecordPageRetention) {
            this.plugins.push(onPageRetentionPlugin);
        }
        if ((config === null || config === void 0 ? void 0 : config.enableRecordAPIPerformance) && (config === null || config === void 0 ? void 0 : config.enableRecordAPIPerformancePercentage) && config.enableRecordAPIPerformancePercentage > 0 && config.enableRecordAPIPerformancePercentage <= 1) {
            this.plugins.push(apiPerformancePlugin);
        }
        this.installPlugins();
    }
    _create_class(AirTracker, [
        {
            key: "installPlugins",
            value: function installPlugins() {
                var _this = this;
                this.plugins.forEach(function(item) {
                    item.patch(_this);
                });
            }
        },
        {
            key: "commonData",
            get: function get() {
                return this._commonData;
            }
        },
        {
            key: "MFECommonDataMap",
            get: function get() {
                return this._MFECommonDataMap;
            }
        },
        {
            key: "initCommonData",
            value: function initCommonData(config) {
                this._commonData.sessionId = config.useSessionStorageForSessionId ? getSessionId() : generateUId();
                this._commonData.deviceId = getDeviceId() || UNKNOWN_VALUE;
                this._commonData.riskDeviceId = getRiskDeviceId();
                this._commonData.networkType = getNetworkType() || "unknown" /* unknown */ ;
                this._commonData.env = config.env || this._commonData.env;
                this._commonData.accountId = config.accountId || UNKNOWN_VALUE;
                this._commonData.appVersion = config.appVersion;
                this._commonData.appName = config.appName;
                this._commonData.sdkVersion = SDK_VERSION;
                this.lifeCycle.emit(lifeCycleEventName.onCommonDataInit, this.commonData);
            }
        },
        {
            key: "updateCommonDataBasedOnConfig",
            value: function updateCommonDataBasedOnConfig(config) {
                this.lifeCycle.emit(lifeCycleEventName.onCommonUpdated, this._commonData);
                this._commonData.env = config.env || this._commonData.env;
                this._commonData.appName = config.appName || this._commonData.appName;
                this._commonData.env = config.env || this._commonData.env;
                this._commonData.accountId = config.accountId || this._commonData.accountId;
                this._commonData.appVersion = config.appVersion || this._commonData.appVersion;
            }
        },
        {
            // Can add extra common data based on developers' needs
            key: "updateCommonData",
            value: function updateCommonData(extraData) {
                this.lifeCycle.emit(lifeCycleEventName.onCommonUpdated, this._commonData);
                this._commonData = _object_spread({}, this._commonData, extraData);
            }
        },
        {
            key: "removeCommonDataByKey",
            value: function removeCommonDataByKey(keys) {
                var _this = this;
                this.lifeCycle.emit(lifeCycleEventName.onCommonUpdated, this._commonData);
                setTimeout(function() {
                    keys.forEach(function(item) {
                        delete _this._commonData[item];
                    });
                }, 1e3);
            }
        },
        {
            // only worked if isWebappContainer is true
            key: "addToMFECommonData",
            value: function addToMFECommonData(param) {
                var MFEName = param.MFEName, MFECommonData = param.MFECommonData;
                var _this__MFECommonDataMap;
                if (!this.config.isWebappContainer) {
                    return;
                }
                if (!MFEName || !MFECommonData) {
                    return;
                }
                this._MFECommonDataMap = _object_spread_props(_object_spread({}, this._MFECommonDataMap || {}), _define_property({}, MFEName, _object_spread({}, ((_this__MFECommonDataMap = this._MFECommonDataMap) === null || _this__MFECommonDataMap === void 0 ? void 0 : _this__MFECommonDataMap[MFEName]) || {}, MFECommonData)));
            }
        },
        {
            // support set config later
            key: "setConfig",
            value: function setConfig(config) {
                var _this = this;
                if (this.config.isWebappContainer) {
                    return;
                }
                var setValue = function(key, value) {
                    _this.config[key] = value;
                };
                Object.entries(config).forEach(function(item) {
                    var _item = _sliced_to_array(item, 2), key = _item[0], val = _item[1];
                    if ((typeof val === "undefined" ? "undefined" : _type_of(val)) !== void 0) {
                        setValue(key, val);
                    }
                });
                this.lifeCycle.emit(lifeCycleEventName.onConfigInit, this.config);
                this.updateCommonDataBasedOnConfig(config);
            }
        },
        {
            // send verbose level log
            key: "verbose",
            value: function verbose(eventName, extraInfo) {
                this.normalLogPipeLine({
                    severity: "verbose" /* VERBOSE */ ,
                    eventName: eventName,
                    extraInfo: extraInfo
                });
            }
        },
        {
            // send HTTP request log
            key: "httpLog",
            value: function httpLog(eventName, extraInfo) {
                this.normalLogPipeLine({
                    severity: "http" /* HTTP */ ,
                    eventName: eventName,
                    extraInfo: extraInfo
                });
            }
        },
        {
            // send info level log
            key: "info",
            value: function info(eventName, extraInfo) {
                this.normalLogPipeLine({
                    severity: "info" /* INFO */ ,
                    eventName: eventName,
                    extraInfo: extraInfo
                });
            }
        },
        {
            // send warn level log
            key: "warn",
            value: function warn(eventName, extraInfo) {
                this.normalLogPipeLine({
                    severity: "warn" /* WARN */ ,
                    eventName: eventName,
                    extraInfo: extraInfo
                });
            }
        },
        {
            // send error level log
            key: "error",
            value: function error(eventName, extraInfo) {
                console.error("error", eventName);
                this.normalLogPipeLine({
                    severity: "error" /* ERROR */ ,
                    eventName: eventName,
                    extraInfo: extraInfo
                });
            }
        },
        {
            // send business related log, usually used for data analysis
            // all the logs with isBusinessData == true, will be sync to bigQuery / looker
            key: "businessLog",
            value: function businessLog(eventName, extraInfo) {
                this.normalLogPipeLine({
                    severity: "info" /* INFO */ ,
                    eventName: eventName,
                    extraInfo: _object_spread_props(_object_spread({}, extraInfo), {
                        isBusinessLog: true
                    })
                });
            }
        },
        {
            // duration: milliseconds
            key: "reportDuration",
            value: function reportDuration(eventName, duration, extraInfo) {
                if (typeof eventName !== "string") {
                    console.warn("reportDuration: eventName (first param) must be a string");
                    return;
                }
                if (typeof duration !== "number") {
                    console.warn("reportDuration: duration (second param) must be number");
                    return;
                }
                if (duration < 0 || duration > 6e4) {
                    console.warn("reportDuration: duration (second param) must between 0 and 60000");
                    return;
                }
                this.normalLogPipeLine({
                    severity: "speed" /* SPEED */ ,
                    eventName: eventName,
                    extraInfo: _object_spread({
                        duration: duration
                    }, extraInfo)
                });
            }
        },
        {
            key: "getTimerKey",
            value: function getTimerKey(eventName) {
                var MFEName = getMFEName(this);
                return this.config.isWebappContainer ? "".concat(MFEName, "_").concat(eventName) : eventName;
            }
        },
        {
            key: "timeStart",
            value: function timeStart(eventName) {
                if (typeof eventName !== "string") {
                    console.warn("time: first param must be a string");
                    return;
                }
                if (this.timeMap[this.getTimerKey(eventName)]) {
                    console.warn("Timer ".concat(eventName, " already exists"));
                }
                this.timeMap[this.getTimerKey(eventName)] = Date.now();
            }
        },
        {
            key: "timeEnd",
            value: function timeEnd(eventName, delta) {
                if (typeof eventName !== "string") {
                    console.warn("timeEnd: first param must be a string");
                    return;
                }
                if (this.timeMap[this.getTimerKey(eventName)]) {
                    var duration = Date.now() - this.timeMap[this.getTimerKey(eventName)] + (delta || 0);
                    this.normalLogPipeLine({
                        severity: "speed" /* SPEED */ ,
                        eventName: eventName,
                        extraInfo: {
                            duration: duration
                        }
                    });
                    delete this.timeMap[this.getTimerKey(eventName)];
                } else {
                    console.warn("Timer key :".concat(eventName, " does not exist"));
                }
            }
        },
        {
            // only worked if isWebappContainer is true
            key: "addToAssetSpeedWhiteListByMFE",
            value: function addToAssetSpeedWhiteListByMFE(param) {
                var MFEName = param.MFEName, whiteList = param.whiteList;
                var _this_config_assetSpeedMonitoringWhiteListByMFE;
                if (!this.config.isWebappContainer) {
                    return;
                }
                if (!MFEName || !(whiteList === null || whiteList === void 0 ? void 0 : whiteList.length)) {
                    return;
                }
                if (!this.config.assetSpeedMonitoringWhiteListByMFE) {
                    this.config.assetSpeedMonitoringWhiteListByMFE = {};
                }
                if (!((_this_config_assetSpeedMonitoringWhiteListByMFE = this.config.assetSpeedMonitoringWhiteListByMFE) === null || _this_config_assetSpeedMonitoringWhiteListByMFE === void 0 ? void 0 : _this_config_assetSpeedMonitoringWhiteListByMFE[MFEName])) {
                    this.config.assetSpeedMonitoringWhiteListByMFE = _object_spread_props(_object_spread({}, this.config.assetSpeedMonitoringWhiteListByMFE), _define_property({}, MFEName, whiteList));
                } else {
                    var _this_config_assetSpeedMonitoringWhiteListByMFE_MFEName;
                    var _this_config_assetSpeedMonitoringWhiteListByMFE_MFEName1, _this_config_assetSpeedMonitoringWhiteListByMFE1;
                    (_this_config_assetSpeedMonitoringWhiteListByMFE1 = this.config.assetSpeedMonitoringWhiteListByMFE) === null || _this_config_assetSpeedMonitoringWhiteListByMFE1 === void 0 ? void 0 : (_this_config_assetSpeedMonitoringWhiteListByMFE_MFEName1 = _this_config_assetSpeedMonitoringWhiteListByMFE1[MFEName]) === null || _this_config_assetSpeedMonitoringWhiteListByMFE_MFEName1 === void 0 ? void 0 : (_this_config_assetSpeedMonitoringWhiteListByMFE_MFEName = _this_config_assetSpeedMonitoringWhiteListByMFE_MFEName1).push.apply(_this_config_assetSpeedMonitoringWhiteListByMFE_MFEName, _to_consumable_array(whiteList));
                }
            }
        },
        {
            // please call destroy from your app root component when your app unmount
            key: "destroy",
            value: function destroy() {
                if (this.config.isWebappContainer) {
                    return;
                }
                this.plugins.forEach(function(item) {
                    item.uninstall();
                });
            }
        }
    ]);
    return AirTracker;
}();
// src/index.ts
var src_default = AirTracker;


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center items-center",staticStyle:{"width":"100%"}},[_c('form',{staticClass:"form-payment-information mb-60",style:({ width: _vm.width })},[_c('div',{staticClass:"col-sm-12 mb-20"},[_c('label',{},[_vm._v("Card Holder Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardHolderName),expression:"cardHolderName"}],staticClass:"form-control alphabets-only",attrs:{"type":"text","placeholder":"Enter card holder name","autocomplete":"off"},domProps:{"value":(_vm.cardHolderName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardHolderName=$event.target.value}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-20"},[_c('label',{staticClass:"required"},[_vm._v("Card Type")]),_vm._v(" "),_c('div',{staticClass:"d-flex"},_vm._l((_vm.cardType),function(item,index){return _c('label',{key:index,staticClass:"cursor-pointer",class:{ 'pl-20': index > 0 },on:{"click":function($event){_vm.selectedCardType = item.value}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCardType),expression:"selectedCardType"}],staticClass:"control-radio",attrs:{"type":"radio"},domProps:{"value":item.value,"checked":_vm.selectedCardType === item.value,"checked":_vm._q(_vm.selectedCardType,item.value)},on:{"change":function($event){_vm.selectedCardType=item.value}}}),_vm._v(" "),_c('span',{staticClass:"pl-5 font-weight-normal v-align-middle"},[_vm._v("\n            "+_vm._s(item.text)+"\n          ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 mb-10"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","id":"btn-payment-information"},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(_vm.nameBtn)+"\n      ")])]),_vm._v(" "),(_vm.showTitle)?_c('div',{staticClass:"col-sm-12 mb-20"},[_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('loader',{attrs:{"content":_vm.msg,"visible":_vm.isLoading}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 mb-20"},[_c('label',{staticClass:"required",attrs:{"for":"card_number"}},[_vm._v("Card Number")]),_vm._v(" "),_c('div',{staticClass:"form-control",attrs:{"id":"card_number"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-20",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"required",attrs:{"for":"expiration_date"}},[_vm._v("Expiration Date")]),_vm._v(" "),_c('div',{staticClass:"form-control",attrs:{"id":"expiration_date"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"required",attrs:{"for":"security_code"}},[_vm._v("CVC")]),_vm._v(" "),_c('div',{staticClass:"form-control",attrs:{"id":"security_code"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instructional-text-wrapper",staticStyle:{"margin-top":"20px"}},[_c('div',{attrs:{"id":"title"}},[_vm._v("Secure Payment Information")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1rem","margin-top":"10px"}},[_vm._v("\n          We take the protection of your financial information seriously. All\n          credit card transactions conducted on this page are encrypted using\n          industry-standard 256-bit Secure Socket Layer (SSL) technology to\n          ensure confidentiality and integrity of your data.\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1rem","margin-top":"15px"}},[_vm._v("\n          Our payment systems are PCI DSS (Payment Card Industry Data Security\n          Standard) compliant, which means we adhere to globally recognised\n          requirements for safeguarding cardholder information. Please note\n          that your full credit card details are never stored on our servers;\n          all transactions are securely processed through our accredited\n          payment gateway partners.\n        ")]),_vm._v(" "),_c('p',{staticStyle:{"line-height":"1rem","margin-top":"15px"}},[_vm._v("\n          Should you require further information regarding our payment\n          security measures, please contact us at\n          "),_c('a',{attrs:{"href":"mailto:support@trransfer.com"}},[_vm._v("support@trransfer.com")]),_vm._v(".\n        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_DeleteModal__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FormCard__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_master_company_companyService_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_master_countryPhoneService_js__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_google_map_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_google_geocode_js__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_TokenizationLinkModal_vue__ = __webpack_require__(1041);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    deleteModal: __WEBPACK_IMPORTED_MODULE_5__components_shared_DeleteModal__["a" /* default */],
    FormCard: __WEBPACK_IMPORTED_MODULE_6__components_shared_FormCard__["a" /* default */],
    TokenizationLinkModal: __WEBPACK_IMPORTED_MODULE_12__components_shared_TokenizationLinkModal_vue__["a" /* default */]
  },
  computed: {
    isAllowToRead: function isAllowToRead() {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function isAllowToCreate() {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function isAllowToUpdate() {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function isAllowToDelete() {
      return this.allPermissions.includes("Delete");
    },
    isAllowToSync: function isAllowToSync() {
      return this.allPermissions.includes("Sync");
    },
    recordInfo: function recordInfo() {
      return this.table.totalRecords > 1 ? this.table.totalRecords + " Records" : this.table.totalRecords + " Record";
    },
    validationRulePassword: function validationRulePassword() {
      return !this.isUpdate ? { maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(100) } : {};
    },
    validationRulePhone: function validationRulePhone() {
      return this.model.modifiedPhones && this.model.modifiedPhones.length > 0 ? {
        $each: {
          code: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
          number: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(20) }
        }
      } : {};
    },
    validationRuleEmail: function validationRuleEmail() {
      return this.model.modifiedEmails && this.model.modifiedEmails.length > 0 ? { $each: { email: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(100) } } } : {};
    }
  },
  data: function data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
        sort: "",
        sortDir: "",
        type: "Unspecified",
        companyIds: ""
      },
      typeOptions: [{ value: "Unspecified", text: "All" }, { value: "CorporateAdmin", text: "Corp. Admin" }, { value: "CorporateBooker", text: "Corp. Booker" }, { value: "CorporateCustomer", text: "Corp. Customer" }],
      cardType: [{ value: "Business", text: "Business" }, { value: "Personal", text: "Personal" }],
      isSubmitted: false,
      activeTab: "general",
      publicSettings: [],
      allPermissions: [],
      itemToBeDeleted: null,
      map: null,
      geocoder: null,
      items: [],
      titles: [],
      companies: [],
      defaultCompanyId: null,
      phoneCodes: [],
      isMarkerChange: false,
      model: {},
      auth: {},
      location: { name: null, address: null, latitude: null, longitude: null },
      paymentList: [],
      selectedCustomerId: null,
      selectedCard: {
        id: "",
        type: "",
        cardHolderName: ""
      },
      selectedCardId: "",
      awClientSecret: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait"
    };
  },
  validations: function validations() {
    return {
      model: {
        title: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        otherTitle: {},
        companyId: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
        fullName: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(150) },
        password: this.validationRulePassword,
        modifiedPhones: this.validationRulePhone,
        modifiedEmails: this.validationRuleEmail
      },
      auth: {
        password: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["maxLength"])(100) }
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var profile, permissions, company;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$helper.scrollTop();
              _context.next = 3;
              return _this.$store.dispatch("setting/getAllPublic");

            case 3:
              _this.publicSettings = _context.sent;

              _this.table.pageSize = _this.$helper.extractSetting(_this.publicSettings, "PageSize", 25);

              _context.next = 7;
              return _this.$store.dispatch("user/getProfile");

            case 7:
              profile = _context.sent;
              permissions = profile.services[_this.$route.name];

              if (permissions) {
                _this.allPermissions = permissions;
              }

              if (!_this.isAllowToRead) {
                _context.next = 19;
                break;
              }

              _context.next = 13;
              return _this.getAll();

            case 13:
              _context.next = 15;
              return _this.getCompanies();

            case 15:
              _context.next = 17;
              return _this.getPhoneCodes();

            case 17:
              _this.titles = [{ value: "Mr", text: "Mr" }, { value: "Mrs", text: "Mrs" }, { value: "Ms", text: "Ms" }, { value: "Other", text: "Others" }];

              if (profile.defaultCompany && _this.companies && _this.companies.length > 0) {
                company = _this.companies.find(function (x) {
                  return x.id == profile.defaultCompany.id;
                });

                if (company) {
                  _this.defaultCompanyId = company.id;
                }
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    $(this.$refs.customermodal).on("hidden.bs.modal", this.closeCustomerModal);
    $(this.$refs.mapmodal).on("hidden.bs.modal", this.closeMapModal);
    $(this.$refs.paymentModal).on("shown.bs.modal", function () {
      _this2.$refs.formCard.resetAirwallex();
    });
    $(this.$refs.paymentModal).on("hidden.bs.modal", function () {
      _this2.$refs.formCard.resetAirwallex();
    });

    if (!this.map) {
      var defaultLatLng = this.$helper.extractSetting(this.publicSettings, "DefaultLatLng", "-6.17003832454938|106.81490242481232");
      var latLng = defaultLatLng.split("|");
      var lat = parseFloat(latLng[0]);
      var lng = parseFloat(latLng[1]);

      // creates map instance
      this.map = new __WEBPACK_IMPORTED_MODULE_10__plugins_google_map_js__["a" /* default */]({
        mapId: "map",
        lat: lat,
        lng: lng,
        marker: true,
        autocomplete: true,
        confirmLocationCallback: this.confirmLocation,
        removeLocationCallback: this.removeLocation,
        autoCompleteGetPlaceCallback: this.getPlace,
        markerChangeCallback: this.markerChange
      });
      this.map.initialize();
    }

    if (!this.geocoder) {
      // creates geocoder instance
      this.geocoder = new __WEBPACK_IMPORTED_MODULE_11__plugins_google_geocode_js__["a" /* default */]();
    }
  },
  updated: function updated() {
    // subscribe message
    this.$eventBus.$on("openCustomerDeleteModal", this.openCustomerDeleteModal);
    this.$helper.collapseMenu("corporate");
    this.$helper.setNavigationClass("customer-link");
    this.$helper.alphabetsOnly();
    this.$helper.numbersOnly();
    this.$helper.disableContextMenu(".readonly");
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("openCustomerDeleteModal");
    document.querySelectorAll(".pac-container").forEach(function (element) {
      return element.remove();
    });
  },

  methods: {
    onChangePageSize: function onChangePageSize() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.table.pageNumber = 1;
                _context2.next = 3;
                return _this3.getAll();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    onKeyupKeyword: function onKeyupKeyword() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this4;

                if (self.timer) {
                  clearTimeout(self.timer);
                  self.timer = null;
                }
                self.timer = setTimeout(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(_) {
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            self.table.pageNumber = 1;
                            _context3.next = 3;
                            return self.getAll();

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), 500);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    onNavigateCallback: function onNavigateCallback(pageNumber) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.table.pageNumber = pageNumber;
                _context5.next = 3;
                return _this5.getAll();

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    onClickSort: function onClickSort(column) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this6.table.sort === column) {
                  _this6.table.sortDir = _this6.table.sortDir === "asc" ? "desc" : "asc";
                } else {
                  _this6.table.sortDir = "asc";
                }
                _this6.table.sort = column;
                _context6.next = 4;
                return _this6.getAll();

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },
    confirmLocation: function confirmLocation(coordinate) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var geocodeResponse;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this7.isMarkerChange) {
                  _context7.next = 5;
                  break;
                }

                _context7.next = 3;
                return _this7.geocoder.geocode(coordinate);

              case 3:
                geocodeResponse = _context7.sent;

                if (geocodeResponse !== undefined && geocodeResponse !== null) {
                  _this7.location.address = geocodeResponse.address;
                  _this7.location.name = geocodeResponse.name;
                  _this7.location.latitude = geocodeResponse.latitude;
                  _this7.location.longitude = geocodeResponse.longitude;
                }

              case 5:
                _this7.$notification.success("Location saved.", { title: "Success" });
                _this7.closeMapModal();

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    removeLocation: function removeLocation() {
      document.getElementById("pac-input").value = "";
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
      this.$notification.success("Location removed.", { title: "Success" });
    },
    getPlace: function getPlace(place) {
      // get place from autocomplete
      this.isMarkerChange = false;
      this.location.name = place.name;
      this.location.address = place.formatted_address;
      this.location.latitude = place.geometry.location.lat();
      this.location.longitude = place.geometry.location.lng();
    },
    markerChange: function markerChange(latLng) {
      this.isMarkerChange = true;
    },
    resetModel: function resetModel() {
      this.isMarkerChange = false;
      this.model = {};
      this.auth = {};
      this.location = {
        name: null,
        address: null,
        latitude: null,
        longitude: null
      };
    },
    resetValidations: function resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.$v.auth.$reset();
    },
    searchPhoneCode: function searchPhoneCode(options, search) {
      var pattern = new RegExp(search.toLowerCase(), "i");
      return this.phoneCodes.filter(function (item) {
        return pattern.test(item.area) || pattern.test(item.country) || pattern.test(item.dial) || pattern.test(item.iata);
      });
    },
    openCustomerModal: function openCustomerModal(item) {
      this.resetValidations();
      this.model = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      if (this.model.addresses && this.model.addresses.length > 0) {
        this.location = this.model.addresses[0].location;
      }
      $(this.$refs.customermodal).modal({
        backdrop: "static",
        keyboard: false
      });
    },
    openMapModal: function openMapModal(item) {
      document.getElementById("pac-input").value = "";
      this.resetValidations();
      if (this.location !== null && this.location.latitude !== null && this.location.longitude !== null) {
        this.map.showMarker(new google.maps.LatLng(this.location.latitude, this.location.longitude));
      } else {
        this.map.hideMarker();
      }
      $(this.$refs.mapmodal).modal({ backdrop: "static", keyboard: false });
    },
    closeCustomerModal: function closeCustomerModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customermodal).modal("hide");
    },
    closeMapModal: function closeMapModal() {
      $(this.$refs.mapmodal).modal("hide");
      $(this.$refs.customermodal).css("overflow-y", "auto");
    },
    openCustomerDeleteModal: function openCustomerDeleteModal(option, id) {
      this.deleteOption = option;
      this.deleteId = id;
      $("#deletemodal").modal();
    },
    openAuthModal: function openAuthModal(item) {
      this.resetValidations();
      this.auth = { id: item.id, password: null };
      $(this.$refs.customerpasswordmodal).modal();
    },
    closeAuthModal: function closeAuthModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.customerpasswordmodal).modal("hide");
    },
    submitAuth: function submitAuth() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.isSubmitted = true;
                _this8.$v.auth.$touch();

                if (!_this8.$v.auth.$error) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt("return");

              case 4:
                _context8.prev = 4;

                _this8.isLoading = true;
                _context8.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].syncAuth(_this8.auth);

              case 8:
                _this8.$notification.success("Successfully synced.", {
                  title: "Success"
                });
                _this8.closeAuthModal();
                _context8.next = 12;
                return _this8.getAll();

              case 12:
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](4);

                if (_context8.t0.errors) {
                  for (index = 0; index < _context8.t0.errors.length; index++) {
                    _this8.$notification.error(_context8.t0.errors[index], { title: "Error" });
                  }
                }

              case 17:
                _context8.prev = 17;

                _this8.isLoading = false;
                return _context8.finish(17);

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[4, 14, 17, 20]]);
      }))();
    },
    createItem: function createItem() {
      this.isUpdate = false;
      this.resetModel();
      this.activeTab = "general";
      this.openCustomerModal({
        companyId: this.defaultCompanyId,
        isAdmin: false,
        isPersonInCharge: false,
        title: "Mr",
        addresses: [],
        modifiedEmails: [{
          id: this.$helper.emptyGuid(),
          email: null,
          isMain: false,
          state: "Created"
        }],
        modifiedPhones: [{
          id: this.$helper.emptyGuid(),
          code: null,
          number: null,
          isMain: false,
          state: "Created"
        }]
      });
    },
    updateItem: function updateItem(item) {
      this.isUpdate = true;
      this.activeTab = "general";
      item.modifiedEmails = [];
      item.modifiedPhones = [];
      var dataModel = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
        title: this.findTitle(item.title, "title"),
        otherTitle: this.findTitle(item.title, "otherTitle")
      });
      this.openCustomerModal(dataModel);
      for (var i = 0; i < this.model.emails.length; i++) {
        this.model.modifiedEmails.push({
          id: this.model.emails[i].id,
          email: this.model.emails[i].email,
          isMain: this.model.emails[i].isMain,
          state: "NoAction"
        });
      }
      for (var _i = 0; _i < this.model.phones.length; _i++) {
        this.model.modifiedPhones.push({
          id: this.model.phones[_i].id,
          code: this.model.phones[_i].code,
          number: this.model.phones[_i].number,
          isMain: this.model.phones[_i].isMain,
          state: "NoAction"
        });
      }
    },
    findTitle: function findTitle(value, type) {
      var findTitle = this.titles.find(function (val) {
        return val.value === value;
      });

      if (type === "title") return findTitle ? value : "Other";else return findTitle ? null : value;
    },
    getAllCompanies: function getAllCompanies() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this9.companies.length === 0)) {
                  _context9.next = 4;
                  break;
                }

                _context9.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 3:
                _this9.companies = _context9.sent;

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this9);
      }))();
    },
    getAll: function getAll() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var filter, response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this10.isAllowToRead) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt("return");

              case 2:
                _context10.prev = 2;

                _this10.isLoading = true;
                filter = "?page=" + _this10.table.pageNumber + "&size=" + _this10.table.pageSize;

                if (_this10.table.keyword && _this10.table.keyword !== "") {
                  filter += "&search=" + _this10.table.keyword;
                }
                if (_this10.table.sort && _this10.table.sort !== "") {
                  filter += "&sort=" + _this10.table.sort + "&sortDir=" + _this10.table.sortDir;
                }
                if (_this10.table.companyIds && _this10.table.companyIds !== "") {
                  filter += "&companyIds=" + _this10.table.companyIds;
                }
                if (_this10.table.type && _this10.table.type !== "") {
                  filter += "&type=" + _this10.table.type;
                }
                _context10.next = 11;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].getAll(filter);

              case 11:
                response = _context10.sent;

                _this10.items = response.data;
                _this10.table.totalPages = response.totalPages;
                _this10.table.totalRecords = response.totalRecords;
                _context10.next = 20;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10["catch"](2);

                if (_context10.t0.errors) {
                  for (index = 0; index < _context10.t0.errors.length; index++) {
                    _this10.$notification.error(_context10.t0.errors[index], { title: "Error" });
                  }
                }

              case 20:
                _context10.prev = 20;

                _this10.isLoading = false;
                return _context10.finish(20);

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this10, [[2, 17, 20, 23]]);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee11() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__services_master_company_companyService_js__["a" /* default */].getAllActive();

              case 2:
                _this11.companies = _context11.sent;

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this11);
      }))();
    },
    getPhoneCodes: function getPhoneCodes() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var i, item;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_master_countryPhoneService_js__["a" /* default */].getAll();

              case 2:
                _this12.phoneCodes = _context12.sent;


                for (i = 0; i < _this12.phoneCodes.length; i++) {
                  item = _this12.phoneCodes[i];

                  item.label = item.iata + " (+" + item.dial + ")";
                  item.icon = "iti-flag " + item.iata.toLowerCase();
                }

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this12);
      }))();
    },
    submit: function submit() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this13.isSubmitted = true;
                _this13.$v.model.$touch();

                if (!_this13.$v.model.$error) {
                  _context13.next = 4;
                  break;
                }

                return _context13.abrupt("return");

              case 4:
                _context13.prev = 4;

                _this13.isLoading = true;
                _this13.model.title = _this13.model.title === "Other" ? _this13.model.otherTitle : _this13.model.title;
                _this13.model.addresses = [];
                if (_this13.location.address !== null && _this13.location.name !== null && _this13.location.latitude !== null && _this13.longitude !== null) {
                  _this13.model.addresses.push({
                    location: _this13.location,
                    isMain: true,
                    state: "Created"
                  });
                }
                _this13.model.isAdmin = _this13.model.isAdmin == "true" || _this13.model.isAdmin == true ? true : false;
                _this13.model.isPersonInCharge = _this13.model.isPersonInCharge == "true" || _this13.model.isPersonInCharge == true ? true : false;
                _this13.model.emails = _this13.model.modifiedEmails.map(function (x) {
                  return x;
                });
                _this13.model.phones = _this13.model.modifiedPhones.map(function (x) {
                  return x;
                });

                if (!_this13.isUpdate) {
                  _context13.next = 19;
                  break;
                }

                _context13.next = 16;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].update(_this13.model);

              case 16:
                _this13.$notification.success("Successfully updated.", {
                  title: "Success"
                });
                _context13.next = 22;
                break;

              case 19:
                _context13.next = 21;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].create(_this13.model);

              case 21:
                _this13.$notification.success("Successfully added.", {
                  title: "Success"
                });

              case 22:
                _this13.closeCustomerModal();
                _context13.next = 25;
                return _this13.getAll();

              case 25:
                _context13.next = 30;
                break;

              case 27:
                _context13.prev = 27;
                _context13.t0 = _context13["catch"](4);

                if (_context13.t0.errors) {
                  for (index = 0; index < _context13.t0.errors.length; index++) {
                    _this13.$notification.error(_context13.t0.errors[index], { title: "Error" });
                  }
                }

              case 30:
                _context13.prev = 30;

                _this13.isLoading = false;
                return _context13.finish(30);

              case 33:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this13, [[4, 27, 30, 33]]);
      }))();
    },
    changeStatus: function changeStatus(item) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this14.isLoading = true;
                _context14.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].changeStatus({
                  id: item.id,
                  isActive: item.isActive
                });

              case 4:
                if (item.isActive) {
                  _this14.$notification.success("Successfully reactivated.", {
                    title: "Success"
                  });
                } else {
                  _this14.$notification.success("Successfully deactivated.", {
                    title: "Success"
                  });
                }
                _context14.next = 7;
                return _this14.getAll();

              case 7:
                _context14.next = 12;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14["catch"](0);

                if (_context14.t0.errors) {
                  for (index = 0; index < _context14.t0.errors.length; index++) {
                    _this14.$notification.error(_context14.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context14.prev = 12;

                _this14.isLoading = false;
                return _context14.finish(12);

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this14, [[0, 9, 12, 15]]);
      }))();
    },
    confirmDelete: function confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    submitDelete: function submitDelete() {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                _this15.isLoading = true;
                _context15.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].delete(_this15.itemToBeDeleted.id);

              case 4:
                _this15.$notification.success("Successfully deleted.", {
                  title: "Success"
                });
                _context15.next = 7;
                return _this15.getAll();

              case 7:
                _context15.next = 12;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15["catch"](0);

                if (_context15.t0.errors) {
                  for (index = 0; index < _context15.t0.errors.length; index++) {
                    _this15.$notification.error(_context15.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context15.prev = 12;

                _this15.isLoading = false;
                return _context15.finish(12);

              case 15:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this15, [[0, 9, 12, 15]]);
      }))();
    },
    printPhone: function printPhone(item) {
      return item && item.length > 0 ? "(+" + item[0].code + ") " + item[0].number : "N/A";
    },
    printEmail: function printEmail(item) {
      return item && item.length > 0 ? "" + item[0].email : "N/A";
    },
    addPhone: function addPhone() {
      this.model.modifiedPhones.push({
        id: this.$helper.emptyGuid(),
        code: null,
        number: null,
        isMain: false,
        state: "Created"
      });
    },
    removePhone: function removePhone(index) {
      this.model.modifiedPhones[index].state = "Deleted";
    },
    addEmail: function addEmail() {
      this.model.modifiedEmails.push({
        id: this.$helper.emptyGuid(),
        email: null,
        isMain: false,
        state: "Created"
      });
    },
    removeEmail: function removeEmail(index) {
      this.model.modifiedEmails[index].state = "Deleted";
    },
    onChangeCustomerItem: function onChangeCustomerItem(item) {
      if (item.id === this.$helper.emptyGuid()) {
        item.state = "Created";
      } else {
        item.state = "Updated";
      }
    },
    openCardModal: function openCardModal(item) {
      var _this16 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee16() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return _this16.getListOfPaymentMethods(item);

              case 2:
                $(_this16.$refs.cardListModal).modal();

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this16);
      }))();
    },
    getListOfPaymentMethods: function getListOfPaymentMethods() {
      var _this17 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee17() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this17.isLoading = true;
                _this17.selectedCustomerId = item && item.id ? item.id : _this17.selectedCustomerId;
                _context17.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].getListOfPaymentMethods(_this17.selectedCustomerId);

              case 5:
                response = _context17.sent;

                if (response.isSuccess) {
                  _this17.paymentList = response.data;
                }
                _context17.next = 12;
                break;

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17["catch"](0);

                if (_context17.t0.errors) {
                  for (index = 0; index < _context17.t0.errors.length; index++) {
                    _this17.$notification.error(_context17.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context17.prev = 12;

                _this17.isLoading = false;
                return _context17.finish(12);

              case 15:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this17, [[0, 9, 12, 15]]);
      }))();
    },
    openPaymentModal: function openPaymentModal() {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this18.isLoading = true;
                _context18.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].getAirwallexClientSecret(_this18.selectedCustomerId);

              case 4:
                response = _context18.sent;

                if (response.isSuccess) {
                  _this18.awClientSecret = response.data;
                  $(_this18.$refs.paymentModal).modal();
                }
                _context18.next = 11;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                if (_context18.t0.errors) {
                  for (index = 0; index < _context18.t0.errors.length; index++) {
                    _this18.$notification.error(_context18.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context18.prev = 11;

                _this18.isLoading = false;
                return _context18.finish(11);

              case 14:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this18, [[0, 8, 11, 14]]);
      }))();
    },
    setDefaultCard: function setDefaultCard(params) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var payload, response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this19.isLoading = true;
                payload = {
                  id: params.id,
                  paymentServiceCustomerId: params.paymentServiceCustomerId
                };
                _context19.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].setDefaultPaymentMethod(payload);

              case 5:
                response = _context19.sent;

                if (response.isSuccess) {
                  _this19.paymentList = _this19.paymentList.map(function (val) {
                    if (val.id === params.id) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val, { isDefault: true });else return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val, { isDefault: false });
                  });
                  _this19.$notification.success("Default card changed.", {
                    title: "Success"
                  });
                }
                _context19.next = 12;
                break;

              case 9:
                _context19.prev = 9;
                _context19.t0 = _context19["catch"](0);

                if (_context19.t0.errors) {
                  for (index = 0; index < _context19.t0.errors.length; index++) {
                    _this19.$notification.error(_context19.t0.errors[index], { title: "Error" });
                  }
                }

              case 12:
                _context19.prev = 12;

                _this19.isLoading = false;
                return _context19.finish(12);

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this19, [[0, 9, 12, 15]]);
      }))();
    },
    editCard: function editCard(item) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee20() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this20.isLoading = true;
                _context20.prev = 1;
                _context20.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].getPaymentMethodById(item.id);

              case 4:
                response = _context20.sent;


                if (response.isSuccess) {
                  _this20.selectedCard = {
                    id: response.data.id,
                    type: response.data.type,
                    cardHolderName: response.data.cardHolderName
                  };
                }
                _context20.next = 11;
                break;

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](1);

                if (_context20.t0.errors) {
                  for (index = 0; index < _context20.t0.errors.length; index++) {
                    _this20.$notification.error(_context20.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context20.prev = 11;

                _this20.isLoading = false;
                $(_this20.$refs.editCard).modal();
                return _context20.finish(11);

              case 15:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this20, [[1, 8, 11, 15]]);
      }))();
    },
    submitEditCard: function submitEditCard() {
      var _this21 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee21() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _this21.isLoading = true;
                _context21.prev = 1;
                _context21.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].updatePaymentMethod(_this21.selectedCard.id, _this21.selectedCard);

              case 4:
                response = _context21.sent;

                if (response.isSuccess) {
                  _this21.paymentList = _this21.paymentList.map(function (val) {
                    if (val.id === _this21.selectedCard.id) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val, {
                      type: _this21.selectedCard.type,
                      cardHolderName: _this21.selectedCard.cardHolderName
                    });else return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, val);
                  });
                  _this21.$notification.success("Successfully changed card type.", {
                    title: "Success"
                  });
                  $(_this21.$refs.editCard).modal("hide");
                }
                _context21.next = 11;
                break;

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21["catch"](1);

                if (_context21.t0.errors) {
                  for (index = 0; index < _context21.t0.errors.length; index++) {
                    _this21.$notification.error(_context21.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context21.prev = 11;

                _this21.isLoading = false;
                return _context21.finish(11);

              case 14:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this21, [[1, 8, 11, 14]]);
      }))();
    },
    openDeleteCardModal: function openDeleteCardModal(cardId) {
      this.selectedCardId = cardId;
      $("#deleteCardModal").modal();
    },
    deleteCard: function deleteCard() {
      var _this22 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var response, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this22.isLoading = true;
                _context22.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].deletePaymentMethod(_this22.selectedCardId);

              case 4:
                response = _context22.sent;

                if (response.isSuccess) {
                  _this22.paymentList = _this22.paymentList.filter(function (val) {
                    return val.id !== _this22.selectedCardId;
                  });
                  _this22.$notification.success("Card deleted successfully.", {
                    title: "Success"
                  });
                }
                _context22.next = 11;
                break;

              case 8:
                _context22.prev = 8;
                _context22.t0 = _context22["catch"](0);

                if (_context22.t0.errors) {
                  for (index = 0; index < _context22.t0.errors.length; index++) {
                    _this22.$notification.error(_context22.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context22.prev = 11;

                _this22.isLoading = false;
                return _context22.finish(11);

              case 14:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this22, [[0, 8, 11, 14]]);
      }))();
    },
    submitCardDetail: function submitCardDetail() {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee23() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this23.getListOfPaymentMethods();
                $(_this23.$refs.paymentModal).modal("hide");

              case 2:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this23);
      }))();
    },
    isExpired: function isExpired(expiryMonth, expiryYear) {
      var now = new Date();

      var expiryDate = new Date(parseInt(expiryYear), parseInt(expiryMonth), 0, 23, 59, 59);

      return now > expiryDate;
    },
    openTokenizationLinkModal: function openTokenizationLinkModal(customerId) {
      var _this24 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var fetchTokenLink, index;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this24.isLoading = true;
                _context24.prev = 1;
                _context24.next = 4;
                return __WEBPACK_IMPORTED_MODULE_8__services_master_customer_customerService_js__["a" /* default */].getTokenizationLink(customerId);

              case 4:
                fetchTokenLink = _context24.sent;


                if (fetchTokenLink.isSuccess) {
                  _this24.$eventBus.$emit("TokenizationLinkModal", fetchTokenLink.data);
                }
                _context24.next = 11;
                break;

              case 8:
                _context24.prev = 8;
                _context24.t0 = _context24["catch"](1);

                if (_context24.t0.errors) {
                  for (index = 0; index < _context24.t0.errors.length; index++) {
                    _this24.$notification.error(_context24.t0.errors[index], { title: "Error" });
                  }
                }

              case 11:
                _context24.prev = 11;

                _this24.isLoading = false;
                return _context24.finish(11);

              case 14:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this24, [[1, 8, 11, 14]]);
      }))();
    }
  }
});

/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isOpen: false,
      isCopy: false,
      msg: "Please wait",
      link: "https://payment-dev.idteknologia.net/token/ClQiXnpcnzmFcNnBpIbPZ7jNedsylEKsieUDpgRFs8LDV0UDVzk0q7SkaxJfN14LevXCM5HWENUrxl9zxnd6q4t0LhZKI7kO8ehLBC6qIpAA6WSBOSYXiCL7d4aYmiXJ6FiPtZynKoPgR21EmC4P2GbRl7kl7FwNDGGM0HTI0yk16z0TXgpVbdawwn8CXwnCnKvJfQriwo7CRF9A59VGDmWh367LXthPbjf5SKUuELrCsdTwE1CpmcfBgwS48JWdekV18KPZ2NtCojTy6UCGlbNTtl0ADgYEj"
    };
  },
  created: function created() {
    this.$eventBus.$on("TokenizationLinkModal", this.initialize);
  },
  beforeDestroy: function beforeDestroy() {
    this.$eventBus.$off("TokenizationLinkModal");
  },

  methods: {
    initialize: function initialize(link) {
      var _this = this;

      this.link = link;
      this.isOpen = true;
      setTimeout(function () {
        $(_this.$refs.TokenizationLinkModal).modal({
          backdrop: "static",
          keyboard: false
        });
      }, 1000);
    },
    handleCopy: function handleCopy() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isCopy = true;
                _context.next = 3;
                return navigator.clipboard.writeText(_this2.link);

              case 3:

                setTimeout(function () {
                  _this2.isCopy = false;
                }, 2000);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    closeModal: function closeModal() {
      this.isOpen = false;
      $(this.$refs.TokenizationLinkModal).modal("hide");
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.68691a58cbe09dd8e93d.js